export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_OFFCANVAS_NAV = 'TOGGLE_OFFCANVAS_NAV';
export const TOGGLE_FIXED_SIDENAV = 'TOGGLE_FIXED_SIDENAV';
export const TOGGLE_FIXED_HEADER = 'TOGGLE_FIXED_HEADER';
export const CHANGE_SIDENAV_WIDTH = 'CHANGE_SIDENAV_WIDTH';
export const TOGGLE_OFFCANVAS_MOBILE_NAV = 'TOGGLE_OFFCANVAS_MOBILE_NAV';
export const CHANGE_COLOR_OPTION = 'CHANGE_COLOR_OPTION';
export const CHANGE_THEME = 'CHANGE_THEME';

export const HTTP_404_ERROR = 'HTTP_404_ERROR';
export const HTTP_500_ERROR = 'HTTP_500_ERROR';

export const PASSWORD_POLICY_FETCH_REQUEST = 'PASSWORD_POLICY_FETCH_REQUEST';
export const PASSWORD_POLICY_FETCH_REQUEST_SUCCESS = 'PASSWORD_POLICY_FETCH_REQUEST_SUCCESS';
export const PASSWORD_POLICY_FETCH_REQUEST_FAILURE = 'PASSWORD_POLICY_FETCH_REQUEST_FAILURE';
export const PASSWORD_POLICY_UPDATE_REQUEST = 'PASSWORD_POLICY_UPDATE_REQUEST';
export const PASSWORD_POLICY_UPDATE_REQUEST_SUCCESS = 'PASSWORD_POLICY_UPDATE_REQUEST_SUCCESS';
export const PASSWORD_POLICY_UPDATE_REQUEST_FAILURE = 'PASSWORD_POLICY_UPDATE_REQUEST_FAILURE';

export const PASSWORD_POLICY_CLEAN_REQUEST = 'PASSWORD_POLICY_CLEAN_REQUEST';

export const GENERAL_SETTING_FETCH_REQUEST = 'GENERAL_SETTING_FETCH_REQUEST';
export const GENERAL_SETTING_FETCH_REQUEST_SUCCESS = 'GENERAL_SETTING_FETCH_REQUEST_SUCCESS';
export const GENERAL_SETTING_FETCH_REQUEST_FAILURE = 'GENERAL_SETTING_FETCH_REQUEST_FAILURE';
export const GENERAL_SETTING_UPDATE_REQUEST = 'GENERAL_SETTING_UPDATE_REQUEST';
export const GENERAL_SETTING_UPDATE_REQUEST_SUCCESS = 'GENERAL_SETTING_UPDATE_REQUEST_SUCCESS';
export const GENERAL_SETTING_UPDATE_REQUEST_FAILURE = 'GENERAL_SETTING_UPDATE_REQUEST_FAILURE';

export const GENERAL_SETTING_CLEAN_REQUEST = 'GENERAL_SETTING_CLEAN_REQUEST';

export const SYSTEM_SETTING_FETCH_REQUEST = 'SYSTEM_SETTING_FETCH_REQUEST';
export const SYSTEM_SETTING_FETCH_REQUEST_SUCCESS = 'SYSTEM_SETTING_FETCH_REQUEST_SUCCESS';
export const SYSTEM_SETTING_FETCH_REQUEST_FAILURE = 'SYSTEM_SETTING_FETCH_REQUEST_FAILURE';
export const SYSTEM_SETTING_UPDATE_REQUEST = 'SYSTEM_SETTING_UPDATE_REQUEST';
export const SYSTEM_SETTING_UPDATE_REQUEST_SUCCESS = 'SYSTEM_SETTING_UPDATE_REQUEST_SUCCESS';
export const SYSTEM_SETTING_UPDATE_REQUEST_FAILURE = 'SYSTEM_SETTING_UPDATE_REQUEST_FAILURE';

export const SYSTEM_SETTING_CLEAN_REQUEST = 'SYSTEM_SETTING_CLEAN_REQUEST';

export const PERMISSION_FETCH_REQUEST = 'PERMISSION_FETCH_REQUEST';
export const PERMISSION_FETCH_REQUEST_SUCCESS = 'PERMISSION_FETCH_REQUEST_SUCCESS';
export const PERMISSION_FETCH_REQUEST_FAILURE = 'PERMISSION_FETCH_REQUEST_FAILURE';

export const PERMISSION_CLEAN_REQUEST = 'PERMISSION_CLEAN_REQUEST';

export const ROLE_FETCH_REQUEST = 'ROLE_FETCH_REQUEST';
export const ROLE_FETCH_REQUEST_SUCCESS = 'ROLE_FETCH_REQUEST_SUCCESS';
export const ROLE_FETCH_REQUEST_FAILURE = 'ROLE_FETCH_REQUEST_FAILURE';
export const ROLE_ADD_REQUEST = 'ROLE_ADD_REQUEST';
export const ROLE_ADD_REQUEST_SUCCESS = 'ROLE_ADD_REQUEST_SUCCESS';
export const ROLE_ADD_REQUEST_FAILURE = 'ROLE_ADD_REQUEST_FAILURE';
export const ROLE_UPDATE_REQUEST = 'ROLE_UPDATE_REQUEST';
export const ROLE_UPDATE_REQUEST_SUCCESS = 'ROLE_UPDATE_REQUEST_SUCCESS';
export const ROLE_UPDATE_REQUEST_FAILURE = 'ROLE_UPDATE_REQUEST_FAILURE';
export const ROLE_FIELD_FILTER_REQUEST = 'ROLE_FIELD_FILTER_REQUEST';
export const ROLE_FIELD_FILTER_REQUEST_SUCCESS = 'ROLE_FIELD_FILTER_REQUEST_SUCCESS';
export const ROLE_FIELD_FILTER_REQUEST_FAILURE = 'ROLE_FIELD_FILTER_REQUEST_FAILURE';

export const ROLE_CLEAN_REQUEST = 'ROLE_CLEAN_REQUEST';
export const ROLE_FIELD_FILTER_CLEAN_REQUEST = 'ROLE_FIELD_FILTER_CLEAN_REQUEST';

export const USER_TYPE_FETCH_REQUEST = 'USER_TYPE_FETCH_REQUEST';
export const USER_TYPE_FETCH_REQUEST_SUCCESS = 'USER_TYPE_FETCH_REQUEST_SUCCESS';
export const USER_TYPE_FETCH_REQUEST_FAILURE = 'USER_TYPE_FETCH_REQUEST_FAILURE';
export const USER_TYPE_CLEAN_REQUEST = 'USER_TYPE_CLEAN_REQUEST';
export const USER_FETCH_REQUEST = 'USER_FETCH_REQUEST';
export const USER_FETCH_REQUEST_SUCCESS = 'USER_FETCH_REQUEST_SUCCESS';
export const USER_FETCH_MERCHANT_USER_SUB_OPERATOR_REQUEST_SUCCESS =
  'USER_FETCH_MERCHANT_USER_SUB_OPERATOR_REQUEST_SUCCESS';
export const USER_FETCH_REQUEST_FAILURE = 'USER_FETCH_REQUEST_FAILURE';
export const USER_ADD_REQUEST = 'USER_ADD_REQUEST';
export const USER_ADD_REQUEST_SUCCESS = 'USER_ADD_REQUEST_SUCCESS';
export const USER_ADD_REQUEST_FAILURE = 'USER_ADD_REQUEST_FAILURE';
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_REQUEST_SUCCESS = 'USER_UPDATE_REQUEST_SUCCESS';
export const USER_UPDATE_REQUEST_FAILURE = 'USER_UPDATE_REQUEST_FAILURE';
export const USER_DETAIL_FETCH_REQUEST = 'USER_DETAIL_FETCH_REQUEST';
export const USER_DETAIL_FETCH_REQUEST_SUCCESS = 'USER_DETAIL_FETCH_REQUEST_SUCCESS';
export const USER_DETAIL_FETCH_REQUEST_FAILURE = 'USER_DETAIL_FETCH_REQUEST_FAILURE';
export const USER_FIELD_FILTER_REQUEST = 'USER_FIELD_FILTER_REQUEST';
export const USER_FIELD_FILTER_REQUEST_SUCCESS = 'USER_FIELD_FILTER_REQUEST_SUCCESS';
export const USER_FIELD_FILTER_REQUEST_FAILURE = 'USER_FIELD_FILTER_REQUEST_FAILURE';

export const PROVINCE_FETCH_REQUEST = 'PROVINCE_FETCH_REQUEST';
export const PROVINCE_FETCH_REQUEST_SUCCESS = 'PROVINCE_FETCH_REQUEST_SUCCESS';
export const PROVINCE_FETCH_REQUEST_FAILURE = 'PROVINCE_FETCH_REQUEST_FAILURE';

export const USER_CLEAN_REQUEST = 'USER_CLEAN_REQUEST';
export const USER_DETAIL_CLEAN_REQUEST = 'USER_DETAIL_CLEAN_REQUEST';
export const USER_FIELD_FILTER_CLEAN_REQUEST = 'USER_FIELD_FILTER_CLEAN_REQUEST';

export const CUSTOM_FIELD_ADD_REQUEST = 'CUSTOM_FIELD_ADD_REQUEST';
export const CUSTOM_FIELD_ADD_REQUEST_SUCCESS = 'CUSTOM_FIELD_ADD_REQUEST_SUCCESS';
export const CUSTOM_FIELD_ADD_REQUEST_FAILURE = 'CUSTOM_FIELD_ADD_REQUEST_FAILURE';
export const CUSTOM_FIELD_FETCH_REQUEST = 'CUSTOM_FIELD_FETCH_REQUEST';
export const CUSTOM_FIELD_FETCH_REQUEST_SUCCESS = 'CUSTOM_FIELD_FETCH_REQUEST_SUCCESS';
export const CUSTOM_FIELD_FETCH_REQUEST_FAILURE = 'CUSTOM_FIELD_FETCH_REQUEST_FAILURE';
export const CUSTOM_FIELD_UPDATE_REQUEST = 'CUSTOM_FIELD_UPDATE_REQUEST';
export const CUSTOM_FIELD_UPDATE_REQUEST_SUCCESS = 'CUSTOM_FIELD_UPDATE_REQUEST_SUCCESS';
export const CUSTOM_FIELD_UPDATE_REQUEST_FAILURE = 'CUSTOM_FIELD_UPDATE_REQUEST_FAILURE';
export const CUSTOM_FIELD_DATATYPE_FETCH_REQUEST = 'CUSTOM_FIELD_DATATYPE_FETCH_REQUEST';
export const CUSTOM_FIELD_DATATYPE_FETCH_REQUEST_SUCCESS =
  'CUSTOM_FIELD_DATATYPE_FETCH_REQUEST_SUCCESS';
export const CUSTOM_FIELD_DATATYPE_FETCH_REQUEST_FAILURE =
  'CUSTOM_FIELD_DATATYPE_FETCH_REQUEST_FAILURE';
export const CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST =
  'CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST';
export const CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_SUCCESS =
  'CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_SUCCESS';
export const CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_FAILURE =
  'CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_FAILURE';
export const CUSTOM_FIELD_MODULE_FETCH_REQUEST = 'CUSTOM_FIELD_MODULE_FETCH_REQUEST';
export const CUSTOM_FIELD_MODULE_FETCH_REQUEST_SUCCESS =
  'CUSTOM_FIELD_MODULE_FETCH_REQUEST_SUCCESS';
export const CUSTOM_FIELD_MODULE_FETCH_REQUEST_FAILURE =
  'CUSTOM_FIELD_MODULE_FETCH_REQUEST_FAILURE';

export const CUSTOM_FIELD_CLEAN_REQUEST = 'CUSTOM_FIELD_CLEAN_REQUEST';
export const CUSTOM_FIELD_DATATYPE_CLEAN_REQUEST = 'CUSTOM_FIELD_DATATYPE_CLEAN_REQUEST';
export const CUSTOM_FIELD_VALIDATION_RULE_CLEAN_REQUEST =
  'CUSTOM_FIELD_VALIDATION_RULE_CLEAN_REQUEST';
export const CUSTOM_FIELD_MODULE_CLEAN_REQUEST = 'CUSTOM_FIELD_MODULE_CLEAN_REQUEST';

export const BRANCH_FETCH_REQUEST = 'BRANCH_FETCH_REQUEST';
export const BRANCH_FETCH_REQUEST_SUCCESS = 'BRANCH_FETCH_REQUEST_SUCCESS';
export const BRANCH_FETCH_REQUEST_FAILURE = 'BRANCH_FETCH_REQUEST_FAILURE';
export const BRANCH_ADD_REQUEST = 'BRANCH_ADD_REQUEST';
export const BRANCH_ADD_REQUEST_SUCCESS = 'BRANCH_ADD_REQUEST_SUCCESS';
export const BRANCH_ADD_REQUEST_FAILURE = 'BRANCH_ADD_REQUEST_FAILURE';
export const BRANCH_FIELD_FILTER_REQUEST = 'BRANCH_FIELD_FILTER_REQUEST';
export const BRANCH_FIELD_FILTER_REQUEST_SUCCESS = 'BRANCH_FIELD_FILTER_REQUEST_SUCCESS';
export const BRANCH_FIELD_FILTER_REQUEST_FAILURE = 'BRANCH_FIELD_FILTER_REQUEST_FAILURE';
export const BRANCH_UPDATE_REQUEST = 'BRANCH_UPDATE_REQUEST';
export const BRANCH_UPDATE_REQUEST_SUCCESS = 'BRANCH_UPDATE_REQUEST_SUCCESS';
export const BRANCH_UPDATE_REQUEST_FAILURE = 'BRANCH_UPDATE_REQUEST_FAILURE';

export const BRANCH_CODE_FETCH_REQUEST = 'BRANCH_CODE_FETCH_REQUEST';
export const BRANCH_CODE_FETCH_REQUEST_SUCCESS = 'BRANCH_CODE_FETCH_REQUEST_SUCCESS';
export const BRANCH_CODE_FETCH_REQUEST_FAILURE = 'BRANCH_CODE_FETCH_REQUEST_FAILURE';
export const BRANCH_CODE_CLEAN_REQUEST = 'BRANCH_CODE_CLEAN_REQUEST';

export const BRANCH_CLEAN_REQUEST = 'BRANCH_CLEAN_REQUEST';
export const BRANCH_FIELD_FILTER_CLEAN_REQUEST = 'BRANCH_FIELD_FILTER_CLEAN_REQUEST';

export const DEPARTMENT_FETCH_REQUEST = 'DEPARTMENT_FETCH_REQUEST';
export const DEPARTMENT_FETCH_REQUEST_SUCCESS = 'DEPARTMENT_FETCH_REQUEST_SUCCESS';
export const DEPARTMENT_FETCH_REQUEST_FAILURE = 'DEPARTMENT_FETCH_REQUEST_FAILURE';
export const DEPARTMENT_FIELD_FILTER_REQUEST = 'DEPARTMENT_FIELD_FILTER_REQUEST';
export const DEPARTMENT_FIELD_FILTER_REQUEST_SUCCESS = 'DEPARTMENT_FIELD_FILTER_REQUEST_SUCCESS';
export const DEPARTMENT_FIELD_FILTER_REQUEST_FAILURE = 'DEPARTMENT_FIELD_FILTER_REQUEST_FAILURE';
export const DEPARTMENT_ADD_REQUEST = 'DEPARTMENT_ADD_REQUEST';
export const DEPARTMENT_ADD_REQUEST_SUCCESS = 'DEPARTMENT_ADD_REQUEST_SUCCESS';
export const DEPARTMENT_ADD_REQUEST_FAILURE = 'DEPARTMENT_ADD_REQUEST_FAILURE';
export const DEPARTMENT_UPDATE_REQUEST = 'DEPARTMENT_UPDATE_REQUEST';
export const DEPARTMENT_UPDATE_REQUEST_SUCCESS = 'DEPARTMENT_UPDATE_REQUEST_SUCCESS';
export const DEPARTMENT_UPDATE_REQUEST_FAILURE = 'DEPARTMENT_UPDATE_REQUEST_FAILURE';

export const DEPARTMENT_CLEAN_REQUEST = 'DEPARTMENT_CLEAN_REQUEST';
export const DEPARTMENT_FIELD_FILTER_CLEAN_REQUEST = 'DEPARTMENT_FIELD_FILTER_CLEAN_REQUEST';

export const OPERATOR_FETCH_REQUEST = 'OPERATOR_FETCH_REQUEST';
export const OPERATOR_FETCH_REQUEST_SUCCESS = 'OPERATOR_FETCH_REQUEST_SUCCESS';
export const OPERATOR_FETCH_REQUEST_FAILURE = 'OPERATOR_FETCH_REQUEST_FAILURE';

export const OPERATOR_ADD_REQUEST = 'OPERATOR_ADD_REQUEST';
export const OPERATOR_ADD_REQUEST_SUCCESS = 'OPERATOR_ADD_REQUEST_SUCCESS';
export const OPERATOR_ADD_REQUEST_FAILURE = 'OPERATOR_ADD_REQUEST_FAILURE';

export const OPERATOR_UPDATE_REQUEST = 'OPERATOR_UPDATE_REQUEST';
export const OPERATOR_UPDATE_REQUEST_SUCCESS = 'OPERATOR_UPDATE_REQUEST_SUCCESS';
export const OPERATOR_UPDATE_REQUEST_FAILURE = 'OPERATOR_UPDATE_REQUEST_FAILURE';

export const OPERATOR_FIELD_FILTER_REQUEST = 'OPERATOR_FIELD_FILTER_REQUEST';
export const OPERATOR_FIELD_FILTER_REQUEST_SUCCESS = 'OPERATOR_FIELD_FILTER_REQUEST_SUCCESS';
export const OPERATOR_FIELD_FILTER_REQUEST_FAILURE = 'OPERATOR_FIELD_FILTER_REQUEST_FAILURE';

export const OPERATOR_CLEAN_REQUEST = 'OPERATOR_CLEAN_REQUEST';
export const OPERATOR_FIELD_FILTER_CLEAN_REQUEST = 'OPERATOR_FIELD_FILTER_CLEAN_REQUEST';

export const OPERATOR_CHART_FETCH_REQUEST = 'OPERATOR_CHART_FETCH_REQUEST';
export const OPERATOR_CHART_FETCH_REQUEST_SUCCESS = 'OPERATOR_CHART_FETCH_REQUEST_SUCCESS';
export const OPERATOR_CHART_FETCH_REQUEST_FAILURE = 'OPERATOR_CHART_FETCH_REQUEST_FAILURE';

export const OPERATOR_COUNT_FETCH_REQUEST = 'OPERATOR_COUNT_FETCH_REQUEST';
export const OPERATOR_COUNT_FETCH_REQUEST_SUCCESS = 'OPERATOR_COUNT_FETCH_REQUEST_SUCCESS';
export const OPERATOR_COUNT_FETCH_REQUEST_FAILURE = 'OPERATOR_COUNT_FETCH_REQUEST_FAILURE';

export const OPERATOR_GROUP_FETCH_REQUEST = 'OPERATOR_GROUP_FETCH_REQUEST';
export const OPERATOR_GROUP_FETCH_REQUEST_SUCCESS = 'OPERATOR_GROUP_FETCH_REQUEST_SUCCESS';
export const OPERATOR_GROUP_FETCH_REQUEST_FAILURE = 'OPERATOR_GROUP_FETCH_REQUEST_FAILURE';

export const OPERATOR_PLUS_GROUP_FETCH_REQUEST = 'OPERATOR_PLUS_GROUP_FETCH_REQUEST';
export const OPERATOR_PLUS_GROUP_FETCH_REQUEST_SUCCESS =
  'OPERATOR_PLUS_GROUP_FETCH_REQUEST_SUCCESS';
export const OPERATOR_PLUS_GROUP_FETCH_REQUEST_FAILURE =
  'OPERATOR_PLUS_GROUP_FETCH_REQUEST_FAILURE';
export const CLEAN_OPERATOR_PLUS_GROUP_REQUEST = 'CLEAN_OPERATOR_PLUS_GROUP_REQUEST';

export const TRANSACTION_FILTER_FIELD_REQUEST = 'TRANSACTION_FILTER_FIELD_REQUEST';
export const TRANSACTION_FILTER_FIELD_REQUEST_SUCCESS = 'TRANSACTION_FILTER_FIELD_REQUEST_SUCCESS';
export const TRANSACTION_FILTER_FIELD_REQUEST_FAILURE = 'TRANSACTION_FILTER_FIELD_REQUEST_FAILURE';
export const TRANSACTION_FILTER_FIELD_CLEAN_REQUEST = 'TRANSACTION_FILTER_FIELD_CLEAN_REQUEST';

export const TRANSACTION_FETCH_REQUEST = 'TRANSACTION_FETCH_REQUEST';
export const TRANSACTION_FETCH_REQUEST_SUCCESS = 'TRANSACTION_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_FETCH_REQUEST_FAILURE = 'TRANSACTION_FETCH_REQUEST_FAILURE';
export const TRANSACTION_CLEAN_REQUEST = 'TRANSACTION_CLEAN_REQUEST';
export const TRANSACTION_DASHBOARD_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_DASHBOARD_FETCH_REQUEST_SUCCESS';

//master merchant
export const MASTER_MERCHANT_REQUEST = 'MASTER_MERCHANT_REQUEST';
export const MASTER_MERCHANT_REQUEST_SUCCESS = 'MASTER_MERCHANT_REQUEST_SUCCESS';
export const MASTER_MERCHANT_REQUEST_FAILURE = 'MASTER_MERCHANT_REQUEST_FAILURE';
export const MASTER_MERCHANT_CLEAN_REQUEST = 'MASTER_MERCHANT_CLEAN_REQUEST';
export const MASTER_MERCHANT_DETAILS_REQUEST = 'MASTER_MERCHANT_DETAILS_REQUEST';
export const MASTER_MERCHANT_DETAILS_REQUEST_SUCCESS = 'MASTER_MERCHANT_DETAILS_REQUEST_SUCCESS';
export const MASTER_MERCHANT_DETAILS_REQUEST_FAILURE = 'MASTER_MERCHANT_DETAILS_REQUEST_FAILURE';
export const MASTER_MERCHANT_DETAILS_CLEAN_REQUEST = 'MASTER_MERCHANT_DETAILS_CLEAN_REQUEST';
export const MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST = 'MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST';
export const MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_SUCCESS =
  'MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_SUCCESS';
export const MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_FAILURE =
  'MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_FAILURE';
export const MASTER_MERCHANT_EXPANDED_DETAILS_CLEAN_REQUEST =
  'MASTER_MERCHANT_EXPANDED_DETAILS_CLEAN_REQUEST';
export const MASTER_MERCHANT_GROUP_LIST_REQUEST = 'MASTER_MERCHANT_GROUP_LIST_REQUEST';
export const MASTER_MERCHANT_GROUP_LIST_REQUEST_SUCCESS =
  'MASTER_MERCHANT_GROUP_LIST_REQUEST_SUCCESS';
export const MASTER_MERCHANT_GROUP_LIST_REQUEST_FAILURE =
  'MASTER_MERCHANT_GROUP_LIST_REQUEST_FAILURE';
export const MASTER_MERCHANT_GROUP_LIST_CLEAN_REQUEST = 'MASTER_MERCHANT_GROUP_LIST_CLEAN_REQUEST';
export const CREATE_MASTER_MERCHANT_REQUEST = 'CREATE_MASTER_MERCHANT_REQUEST';
export const CREATE_MASTER_MERCHANT_REQUEST_SUCCESS = 'CREATE_MASTER_MERCHANT_REQUEST_SUCCESS';
export const CREATE_MASTER_MERCHANT_REQUEST_FAILURE = 'CREATE_MASTER_MERCHANT_REQUEST_FAILURE';
export const CREATE_MASTER_MERCHANT_CLEAN_REQUEST = 'CREATE_MASTER_MERCHANT_CLEAN_REQUEST';
export const EDIT_MASTER_MERCHANT_REQUEST = 'EDIT_MASTER_MERCHANT_REQUEST';
export const EDIT_MASTER_MERCHANT_REQUEST_SUCCESS = 'EDIT_MASTER_MERCHANT_REQUEST_SUCCESS';
export const EDIT_MASTER_MERCHANT_REQUEST_FAILURE = 'EDIT_MASTER_MERCHANT_REQUEST_FAILURE';
export const EDIT_MASTER_MERCHANT_CLEAN_REQUEST = 'EDIT_MASTER_MERCHANT_CLEAN_REQUEST';

//todays txn
export const TODAY_TRANSACTION_FETCH_REQUEST = 'TODAY_TRANSACTION_FETCH_REQUEST';
export const TODAY_TRANSACTION_FETCH_REQUEST_SUCCESS = 'TODAY_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const TODAY_TRANSACTION_FETCH_REQUEST_FAILURE = 'TODAY_TRANSACTION_FETCH_REQUEST_FAILURE';
export const TODAY_TRANSACTION_CLEAN_REQUEST = 'TODAY_TRANSACTION_CLEAN_REQUEST';
//monthly txn
export const MONTHLY_TRANSACTION_FETCH_REQUEST = 'MONTHLY_TRANSACTION_FETCH_REQUEST';
export const MONTHLY_TRANSACTION_FETCH_REQUEST_SUCCESS =
  'MONTHLY_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const MONTHLY_TRANSACTION_FETCH_REQUEST_FAILURE =
  'MONTHLY_TRANSACTION_FETCH_REQUEST_FAILURE';
export const MONTHLY_TRANSACTION_CLEAN_REQUEST = 'MONTHLY_TRANSACTION_CLEAN_REQUEST';

// All txn
export const ALL_TRANSACTION_FETCH_REQUEST = 'ALL_TRANSACTION_FETCH_REQUEST';
export const ALL_TRANSACTION_FETCH_REQUEST_SUCCESS = 'ALL_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const ALL_TRANSACTION_FETCH_REQUEST_FAILURE = 'ALL_TRANSACTION_FETCH_REQUEST_FAILURE';
export const ALL_TRANSACTION_CLEAN_REQUEST = 'ALL_TRANSACTION_CLEAN_REQUEST';

//watchlist
export const WATCHLIST_TRANSACTION_FETCH_REQUEST = 'WATCHLIST_TRANSACTION_FETCH_REQUEST';
export const WATCHLIST_TRANSACTION_FETCH_REQUEST_SUCCESS =
  'WATCHLIST_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const WATCHLIST_TRANSACTION_FETCH_REQUEST_FAILURE =
  'WATCHLIST_TRANSACTION_FETCH_REQUEST_FAILURE';
export const WATCHLIST_TRANSACTION_CLEAN_REQUEST = 'WATCHLIST_TRANSACTION_CLEAN_REQUEST';

//txn payment request
export const TRANSACTION_PAYMENT_FETCH_REQUEST = 'TRANSACTION_PAYMENT_FETCH_REQUEST';
export const TRANSACTION_PAYMENT_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_PAYMENT_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_PAYMENT_FETCH_REQUEST_FAILURE =
  'TRANSACTION_PAYMENT_FETCH_REQUEST_FAILURE';
export const TRANSACTION_PAYMENT_CLEAN_REQUEST = 'TRANSACTION_PAYMENT_CLEAN_REQUEST';

// txn hitCountList/summary
export const TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST = 'TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST';
export const TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_FAILURE =
  'TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_FAILURE';
export const TRANSACTION_HIT_COUNT_LIST_CLEAN_REQUEST = 'TRANSACTION_HIT_COUNT_LIST_CLEAN_REQUEST';

//txn count and Amount summary

export const TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST = 'TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST';
export const TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_SUCCESS =
  'TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_SUCCESS';
export const TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_FAILURE =
  'TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_FAILURE';
export const TXN_COUNT_AMOUNT_SUMMARY_CLEAN_REQUEST = 'TXN_COUNT_AMOUNT_SUMMARY_CLEAN_REQUEST';

//txn count and amount today
export const TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST = 'TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST';
export const TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS =
  'TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS';
export const TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE =
  'TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE';
export const TODAY_TXN_COUNT_AMOUNT_CLEAN_REQUEST = 'TODAY_TXN_COUNT_AMOUNT_CLEAN_REQUEST';

//txn count and amount monthly
export const MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST = 'MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST';
export const MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS =
  'MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS';
export const MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE =
  'MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE';
export const MONTHLY_TXN_COUNT_AMOUNT_CLEAN_REQUEST = 'MONTHLY_TXN_COUNT_AMOUNT_CLEAN_REQUEST';
//All txn count and amount
export const ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST = 'ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST';
export const ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS =
  'ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS';
export const ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE =
  'ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE';
export const ALL_TXN_COUNT_AMOUNT_CLEAN_REQUEST = 'ALL_TXN_COUNT_AMOUNT_CLEAN_REQUEST';

//
export const UPLOAD_TRANSACTION_REQUEST = 'UPLOAD_TRANSACTION_REQUEST';
export const UPLOAD_TRANSACTION_REQUEST_SUCCESS = 'UPLOAD_TRANSACTION_REQUEST_SUCCESS';
export const UPLOAD_TRANSACTION_REQUEST_FAILURE = 'UPLOAD_TRANSACTION_REQUEST_FAILURE';

export const UPLOAD_TRANSACTION_FETCH_REQUEST = 'UPLOAD_TRANSACTION_FETCH_REQUEST';
export const UPLOAD_TRANSACTION_FETCH_REQUEST_SUCCESS = 'UPLOAD_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const UPLOAD_TRANSACTION_FETCH_REQUEST_FAILURE = 'UPLOAD_TRANSACTION_FETCH_REQUEST_FAILURE';

export const IMPORT_FILE_REQUEST = 'IMPORT_FILE_REQUEST';
export const IMPORT_FILE_REQUEST_SUCCESS = 'IMPORT_FILE_REQUEST_SUCCESS';
export const IMPORT_FILE_REQUEST_FAILURE = 'IMPORT_FILE_REQUEST_FAILURE';

export const ACTIVITY_LOG_FETCH_REQUEST = 'ACTIVITY_LOG_FETCH_REQUEST';
export const ACTIVITY_LOG_FETCH_REQUEST_SUCCESS = 'ACTIVITY_LOG_FETCH_REQUEST_SUCCESS';
export const ACTIVITY_LOG_FETCH_REQUEST_FAILURE = 'ACTIVITY_LOG_FETCH_REQUEST_FAILURE';
export const ACTIVITY_LOG_CLEAN_REQUEST = 'ACTIVITY_LOG_CLEAN_REQUEST';

export const TRANSACTION_RULE_FETCH_REQUEST = 'TRANSACTION_RULE_FETCH_REQUEST';
export const TRANSACTION_RULE_FETCH_REQUEST_SUCCESS = 'TRANSACTION_RULE_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_RULE_FETCH_REQUEST_FAILURE = 'TRANSACTION_RULE_FETCH_REQUEST_FAILURE';

export const TRANSACTION_RULE_FIELD_FILTER_REQUEST = 'TRANSACTION_RULE_FIELD_FILTER_REQUEST';
export const TRANSACTION_RULE_FIELD_FILTER_REQUEST_SUCCESS =
  'TRANSACTION_RULE_FIELD_FILTER_REQUEST_SUCCESS';
export const TRANSACTION_RULE_FIELD_FILTER_REQUEST_FAILURE =
  'TRANSACTION_RULE_FIELD_FILTER_REQUEST_FAILURE';

export const TRANSACTION_RULE_APP_REQUEST = 'TRANSACTION_RULE_APP_REQUEST';
export const TRANSACTION_RULE_APP_REQUEST_SUCCESS = 'TRANSACTION_RULE_APP_REQUEST_SUCCESS';
export const TRANSACTION_RULE_APP_REQUEST_FAILURE = 'TRANSACTION_RULE_APP_REQUEST_FAILURE';

export const TRANSACTION_RULE_FEE_CHARGE_REQUEST = 'TRANSACTION_RULE_FEE_CHARGE_REQUEST';
export const TRANSACTION_RULE_FEE_CHARGE_REQUEST_SUCCESS =
  'TRANSACTION_RULE_FEE_CHARGE_REQUEST_SUCCESS';
export const TRANSACTION_RULE_FEE_CHARGE_REQUEST_FAILURE =
  'TRANSACTION_RULE_FEE_CHARGE_REQUEST_FAILURE';

export const TRANSACTION_RULE_COMMISSION_BASIS_REQUEST =
  'TRANSACTION_RULE_COMMISSION_BASIS_REQUEST';
export const TRANSACTION_RULE_COMMISSION_BASIS_REQUEST_SUCCESS =
  'TRANSACTION_RULE_COMMISSION_BASIS_REQUEST_SUCCESS';
export const TRANSACTION_RULE_COMMISSION_BASIS_REQUEST_FAILURE =
  'TRANSACTION_RULE_COMMISSION_BASIS_REQUEST_FAILURE';

export const TRANSACTION_RULE_COMMISSION_TYPE_REQUEST = 'TRANSACTION_RULE_COMMISSION_TYPE_REQUEST';
export const TRANSACTION_RULE_COMMISSION_TYPE_REQUEST_SUCCESS =
  'TRANSACTION_RULE_COMMISSION_TYPE_REQUEST_SUCCESS';
export const TRANSACTION_RULE_COMMISSION_TYPE_REQUEST_FAILURE =
  'TRANSACTION_RULE_COMMISSION_TYPE_REQUEST_FAILURE';

export const TRANSACTION_RULE_APPLICABLE_GROUP_REQUEST =
  'TRANSACTION_RULE_APPLICABLE_GROUP_REQUEST';
export const TRANSACTION_RULE_APPLICABLE_GROUP_REQUEST_SUCCESS =
  'TRANSACTION_RULE_APPLICABLE_GROUP_REQUEST_SUCCESS';
export const TRANSACTION_RULE_APPLICABLE_GROUP_REQUEST_FAILURE =
  'TRANSACTION_RULE_APPLICABLE_GROUP_REQUEST_FAILURE';

export const TRANSACTION_RULE_ADD_REQUEST = 'TRANSACTION_RULE_ADD_REQUEST';
export const TRANSACTION_RULE_ADD_REQUEST_SUCCESS = 'TRANSACTION_RULE_ADD_REQUEST_SUCCESS';
export const TRANSACTION_RULE_ADD_REQUEST_FAILURE = 'TRANSACTION_RULE_ADD_REQUEST_FAILURE';

export const TRANSACTION_RULE_UPDATE_REQUEST = 'TRANSACTION_RULE_UPDATE_REQUEST';
export const TRANSACTION_RULE_UPDATE_REQUEST_SUCCESS = 'TRANSACTION_RULE_UPDATE_REQUEST_SUCCESS';
export const TRANSACTION_RULE_UPDATE_REQUEST_FAILURE = 'TRANSACTION_RULE_UPDATE_REQUEST_FAILURE';

export const TRANSACTION_RULE_CLEAN_REQUEST = 'TRANSACTION_RULE_CLEAN_REQUEST';
export const TRANSACTION_RULE_FIELD_FILTER_CLEAN_REQUEST =
  'TRANSACTION_RULE_FIELD_FILTER_CLEAN_REQUEST';

export const TERMINAL_FETCH_REQUEST = 'TERMINAL_FETCH_REQUEST';
export const TERMINAL_FETCH_REQUEST_SUCCESS = 'TERMINAL_FETCH_REQUEST_SUCCESS';
export const TERMINAL_FETCH_REQUEST_FAILURE = 'TERMINAL_FETCH_REQUEST_FAILURE';

export const TERMINAL_STATUS_FETCH_REQUEST_SUCCESS = 'TERMINAL_STATUS_FETCH_REQUEST_SUCCESS';

export const TERMINAL_ADD_REQUEST = 'TERMINAL_ADD_REQUEST';
export const TERMINAL_ADD_REQUEST_SUCCESS = 'TERMINAL_ADD_REQUEST_SUCCESS';
export const TERMINAL_ADD_REQUEST_FAILURE = 'TERMINAL_ADD_REQUEST_FAILURE';

export const TERMINAL_UPDATE_REQUEST = 'TERMINAL_UPDATE_REQUEST';
export const TERMINAL_UPDATE_REQUEST_SUCCESS = 'TERMINAL_UPDATE_REQUEST_SUCCESS';
export const TERMINAL_UPDATE_REQUEST_FAILURE = 'TERMINAL_UPDATE_REQUEST_FAILURE';

export const TERMINAL_TOGGLE_LOCK_REQUEST = 'TERMINAL_TOGGLE_LOCK_REQUEST';
export const TERMINAL_TOGGLE_LOCK_REQUEST_SUCCESS = 'TERMINAL_TOGGLE_LOCK_REQUEST_SUCCESS';
export const TERMINAL_TOGGLE_LOCK_REQUEST_FAILURE = 'TERMINAL_TOGGLE_LOCK_REQUEST_FAILURE';

export const TERMINAL_LOCATION_FETCH_REQUEST = 'TERMINAL_LOCATION_FETCH_REQUEST';
export const TERMINAL_LOCATION_FETCH_REQUEST_SUCCESS = 'TERMINAL_LOCATION_FETCH_REQUEST_SUCCESS';
export const TERMINAL_LOCATION_FETCH_REQUEST_FAILURE = 'TERMINAL_LOCATION_FETCH_REQUEST_FAILURE';

export const TERMINAL_GROUP_FETCH_REQUEST = 'TERMINAL_GROUP_FETCH_REQUEST';
export const TERMINAL_GROUP_FETCH_REQUEST_SUCCESS = 'TERMINAL_GROUP_FETCH_REQUEST_SUCCESS';
export const TERMINAL_GROUP_FETCH_REQUEST_FAILURE = 'TERMINAL_GROUP_FETCH_REQUEST_FAILURE';

export const TERMINAL_LOCATION_EVENT_REQUEST = 'TERMINAL_LOCATION_EVENT_REQUEST';
export const TERMINAL_LOCATION_EVENT_REQUEST_SUCCESS = 'TERMINAL_LOCATION_EVENT_REQUEST_SUCCESS';
export const TERMINAL_LOCATION_EVENT_REQUEST_FAILURE = 'TERMINAL_LOCATION_EVENT_REQUEST_FAILURE';

export const TERMINAL_COUNT_FETCH_REQUEST = 'TERMINAL_COUNT_FETCH_REQUEST';
export const TERMINAL_COUNT_FETCH_REQUEST_SUCCESS = 'TERMINAL_COUNT_FETCH_REQUEST_SUCCESS';
export const TERMINAL_COUNT_FETCH_REQUEST_FAILURE = 'TERMINAL_COUNT_FETCH_REQUEST_FAILURE';

export const TERMINAL_FIELD_FILTER_REQUEST = 'TERMINAL_FIELD_FILTER_REQUEST';
export const TERMINAL_FIELD_FILTER_REQUEST_SUCCESS = 'TERMINAL_FIELD_FILTER_REQUEST_SUCCESS';
export const TERMINAL_FIELD_FILTER_REQUEST_FAILURE = 'TERMINAL_FIELD_FILTER_REQUEST_FAILURE';

export const TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST =
  'TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST';
export const TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_SUCCESS =
  'TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_SUCCESS';
export const TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_FAILURE =
  'TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_FAILURE';
export const TERMINAL_INSTALLED_APP_FIELD_FILTER_CLEAN_REQUEST =
  'TERMINAL_INSTALLED_APP_FIELD_FILTER_CLEAN_REQUEST';

export const FETCH_ACTION_DROPDOWN_REQUEST = 'FETCH_ACTION_DROPDOWN_REQUEST';
export const FETCH_ACTION_DROPDOWN_SUCCESS = 'FETCH_ACTION_DROPDOWN_SUCCESS';
export const FETCH_ACTION_DROPDOWN_FAILURE = 'FETCH_ACTION_DROPDOWN_FAILURE';

export const TERMINAL_GEOFENCING_FETCH_REQUEST = 'TERMINAL_GEOFENCING_FETCH_REQUEST';
export const TERMINAL_GEOFENCING_FETCH_REQUEST_SUCCESS =
  'TERMINAL_GEOFENCING_FETCH_REQUEST_SUCCESS';
export const TERMINAL_GEOFENCING_FETCH_REQUEST_FAILURE =
  'TERMINAL_GEOFENCING_FETCH_REQUEST_FAILURE';

export const TERMINAL_CHART_SUMMARY = 'TERMINAL_CHART_SUMMARY';
export const TERMINAL_CHART_SUMMARY_SUCCESS = 'TERMINAL_CHART_SUMMARY_SUCCESS';
export const TERMINAL_CHART_SUMMARY_FAILURE = 'TERMINAL_CHART_SUMMARY_FAILURE';

export const MCC_CHART_SUMMARY_REQUEST = 'MCC_CHART_SUMMARY_REQUEST';
export const MCC_CHART_SUMMARY_REQUEST_SUCCESS = ' MCC_CHART_SUMMARY_REQUEST_SUCCESS';
export const MCC_CHART_SUMMARY_REQUEST_FAILURE = 'MCC_CHART_SUMMARY_REQUEST_FAILURE';

export const MCC_DETAIL_REQUEST = 'MCC_DETAIL_REQUEST';
export const MCC_DETAIL_REQUEST_SUCCESS = 'MCC_DETAIL_REQUEST_SUCCESS';
export const MCC_DETAIL_REQUEST_FAILURE = 'MCC_DETAIL_REQUEST_FAILURE';

export const MCC_CLEAN_REQUEST = 'MCC_CLEAN_REQUEST';

export const TERMINAL_GEOFENCING_UPDATE_REQUEST = 'TERMINAL_GEOFENCING_UPDATE_REQUEST';
export const TERMINAL_GEOFENCING_UPDATE_REQUEST_SUCCESS =
  'TERMINAL_GEOFENCING_UPDATE_REQUEST_SUCCESS';
export const TERMINAL_GEOFENCING_UPDATE_REQUEST_FAILURE =
  'TERMINAL_GEOFENCING_UPDATE_REQUEST_FAILURE';

export const TERMINAL_INSTALLED_APP_FETCH_REQUEST = 'TERMINAL_INSTALLED_APP_FETCH_REQUEST';
export const TERMINAL_INSTALLED_APP_FETCH_REQUEST_SUCCESS =
  'TERMINAL_INSTALLED_APP_FETCH_REQUEST_SUCCESS';
export const TERMINAL_INSTALLED_APP_FETCH_REQUEST_FAILURE =
  'TERMINAL_INSTALLED_APP_FETCH_REQUEST_FAILURE';

export const TERMINAL_INSTALLED_APP_EVENT_REQUEST = 'TERMINAL_INSTALLED_APP_EVENT_REQUEST';
export const TERMINAL_INSTALLED_APP_EVENT_REQUEST_SUCCESS =
  'TERMINAL_INSTALLED_APP_EVENT_REQUEST_SUCCESS';
export const TERMINAL_INSTALLED_APP_EVENT_REQUEST_FAILURE =
  'TERMINAL_INSTALLED_APP_EVENT_REQUEST_FAILURE';

export const TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST = 'TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST';
export const TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_SUCCESS =
  'TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_SUCCESS';
export const TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_FAILURE =
  'TERMINAL_INSTALLED_APP_TAB_FETCH_REQUEST_FAILURE';
export const TERMINAL_INSTALLED_APP_TAB_CLEAN_REQUEST = 'TERMINAL_INSTALLED_APP_TAB_CLEAN_REQUEST';

export const TERMINAL_MANUAL_ENABLED_FETCH_REQUEST = 'TERMINAL_MANUAL_ENABLED_FETCH_REQUEST';
export const TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_SUCCESS =
  'TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_SUCCESS';
export const TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_FAILURE =
  'TERMINAL_MANUAL_ENABLED_FETCH_REQUEST_FAILURE';
export const TERMINAL_MANUAL_ENABLED_CLEAN_REQUEST = 'TERMINAL_MANUAL_ENABLED_CLEAN_REQUEST';

export const TERMINAL_SUMMARY_FETCH_REQUEST = 'TERMINAL_SUMMARY_FETCH_REQUEST';
export const TERMINAL_SUMMARY_FETCH_REQUEST_SUCCESS = 'TERMINAL_SUMMARY_FETCH_REQUEST_SUCCESS';
export const TERMINAL_SUMMARY_FETCH_REQUEST_FAILURE = 'TERMINAL_SUMMARY_FETCH_REQUEST_FAILURE';
export const TERMINAL_SUMMARY_CLEAN_REQUEST = 'TERMINAL_SUMMARY_CLEAN_REQUEST';

export const TERMINAL_SUMMARY_LIST_FETCH_REQUEST = 'TERMINAL_SUMMARY_LIST_FETCH_REQUEST';
export const TERMINAL_SUMMARY_LIST_FETCH_REQUEST_SUCCESS =
  'TERMINAL_SUMMARY_LIST_FETCH_REQUEST_SUCCESS';
export const TERMINAL_SUMMARY_LIST_FETCH_REQUEST_FAILURE =
  'TERMINAL_SUMMARY_LIST_FETCH_REQUEST_FAILURE';
export const TERMINAL_SUMMARY_LIST_CLEAN_REQUEST = 'TERMINAL_SUMMARY_LIST_CLEAN_REQUEST';

export const TERMINAL_INSTALLED_APP_LOG_FETCH_REQUEST = 'TERMINAL_INSTALLED_APP_LOG_FETCH_REQUEST';
export const TERMINAL_INSTALLED_APP_LOG_FETCH_REQUEST_SUCCESS =
  'TERMINAL_INSTALLED_APP__LOG_FETCH_REQUEST_SUCCESS';
export const TERMINAL_INSTALLED_APP_LOG_FETCH_REQUEST_FAILURE =
  'TERMINAL_INSTALLED_APP_LOG_FETCH_REQUEST_FAILURE';

export const TERMINAL_MEMBER_BANK_FETCH_REQUEST = 'TERMINAL_MEMBER_BANK_FETCH_REQUEST';
export const TERMINAL_MEMBER_BANK_FETCH_REQUEST_SUCCESS =
  'TERMINAL_MEMBER_BANK_FETCH_REQUEST_SUCCESS';
export const TERMINAL_MEMBER_BANK_FETCH_REQUEST_FAILURE =
  'TERMINAL_MEMBER_BANK_FETCH_REQUEST_SUCCESS';

export const TERMINAL_DISPATCH_FETCH_REQUEST = 'TERMINAL_DISPATCH_FETCH_REQUEST';
export const TERMINAL_DISPATCH_FETCH_REQUEST_SUCCESS = 'TERMINAL_DISPATCH_FETCH_REQUEST_SUCCESS';
export const TERMINAL_DISPATCH_FETCH_REQUEST_FAILURE = 'TERMINAL_DISPATCH_FETCH_REQUEST_FAILURE';

export const TERMINAL_DISPATCH_ADD_REQUEST = 'TERMINAL_DISPATCH_ADD_REQUEST';
export const TERMINAL_DISPATCH_ADD_REQUEST_SUCCESS = 'TERMINAL_DISPATCH_ADD_REQUEST_SUCCESS';
export const TERMINAL_DISPATCH_ADD_REQUEST_FAILURE = 'TERMINAL_DISPATCH_ADD_REQUEST_FAILURE';

export const TERMINAL_DISPATCH_UPDATE_REQUEST = 'TERMINAL_DISPATCH_UPDATE_REQUEST';
export const TERMINAL_DISPATCH_UPDATE_REQUEST_SUCCESS = 'TERMINAL_DISPATCH_UPDATE_REQUEST_SUCCESS';
export const TERMINAL_DISPATCH_UPDATE_REQUEST_FAILURE = 'TERMINAL_DISPATCH_UPDATE_REQUEST_FAILURE';

export const TERMINAL_TYPE_FETCH_REQUEST = 'TERMINAL_TYPE_FETCH_REQUEST';
export const TERMINAL_TYPE_FETCH_REQUEST_SUCCESS = 'TERMINAL_TYPE_FETCH_REQUEST_SUCCESS';
export const TERMINAL_TYPE_FETCH_REQUEST_FAILURE = 'TERMINAL_TYPE_FETCH_REQUEST_FAILURE';

export const TERMINAL_RESET_REQUEST = 'TERMINAL_RESET_REQUEST';
export const TERMINAL_RESET_REQUEST_SUCCESS = 'TERMINAL_RESET_REQUEST_SUCCESS';
export const TERMINAL_RESET_REQUEST_FAILURE = 'TERMINAL_RESET_REQUEST_FAILURE';

export const TERMINAL_DELETE_REQUEST = 'TERMINAL_DELETE_REQUEST';
export const TERMINAL_DELETE_REQUEST_SUCCESS = 'TERMINAL_DELETE_REQUEST_SUCCESS';
export const TERMINAL_DELETE_REQUEST_FAILURE = 'TERMINAL_DELETE_REQUEST_FAILURE';

export const TERMINAL_RESET_CLEAN_REQUEST = 'TERMINAL_RESET_CLEAN_REQUEST';
export const TERMINAL_INSTALLED_APP_LOG_CLEAN_REQUEST = 'TERMINAL_INSTALLED_APP_LOG_CLEAN_REQUEST';
export const TERMINAL_TYPE_CLEAN_REQUEST = 'TERMINAL_TYPE_CLEAN_REQUEST';

export const TERMINAL_MODEL_ADD_REQUEST = 'TERMINAL_MODEL_ADD_REQUEST';
export const TERMINAL_MODEL_ADD_REQUEST_SUCCESS = 'TERMINAL_MODEL_ADD_REQUEST_SUCCESS';
export const TERMINAL_MODEL_ADD_REQUEST_FAILURE = 'TERMINAL_MODEL_ADD_REQUEST_FAILURE';

export const TERMINAL_MODEL_FETCH_REQUEST = 'TERMINAL_MODEL_FETCH_REQUEST';
export const TERMINAL_MODEL_FETCH_REQUEST_SUCCESS = 'TERMINAL_MODEL_FETCH_REQUEST_SUCCESS';
export const TERMINAL_MODEL_FETCH_REQUEST_FAILURE = 'TERMINAL_MODEL_FETCH_REQUEST_FAILURE';

export const TERMINAL_MODEL_UPDATE_REQUEST = 'TERMINAL_MODEL_UPDATE_REQUEST';
export const TERMINAL_MODEL_UPDATE_REQUEST_SUCCESS = 'TERMINAL_MODEL_UPDATE_REQUEST_SUCCESS';
export const TERMINAL_MODEL_UPDATE_REQUEST_FAILURE = 'TERMINAL_MODEL_UPDATE_REQUEST_FAILURE';

export const TERMINAL_MODEL_FIELD_FILTER_REQUEST = 'TERMINAL_MODEL_FIELD_FILTER_REQUEST';
export const TERMINAL_MODEL_FIELD_FILTER_REQUEST_SUCCESS =
  'TERMINAL_MODEL_FIELD_FILTER_REQUEST_SUCCESS';
export const TERMINAL_MODEL_FIELD_FILTER_REQUEST_FAILURE =
  'TERMINAL_MODEL_FIELD_FILTER_REQUEST_FAILURE';

export const TERMINAL_CLEAN_REQUEST = 'TERMINAL_CLEAN_REQUEST';
export const TERMINAL_ERROR_CLEAN_REQUEST = 'TERMINAL_ERROR_CLEAN_REQUEST';
export const TERMINAL_FIELD_FILTER_CLEAN_REQUEST = 'TERMINAL_FIELD_FILTER_CLEAN_REQUEST';
export const TERMINAL_LOCATION_CLEAN_REQUEST = 'TERMINAL_LOCATION_CLEAN_REQUEST';
export const TERMINAL_TOGGLE_LOCK_CLEAN_REQUEST = 'TERMINAL_TOGGLE_LOCK_CLEAN_REQUEST';
export const TERMINAL_GEOFENCING_CLEAN_REQUEST = 'TERMINAL_GEOFENCING_CLEAN_REQUEST';
export const TERMINAL_INSTALLED_APP_CLEAN_REQUEST = 'TERMINAL_INSTALLED_APP_CLEAN_REQUEST';
export const TERMINAL_INSTALLED_APP_EVENT_CLEAN_REQUEST =
  'TERMINAL_INSTALLED_APP_EVENT_CLEAN_REQUEST';
export const TERMINAL_MODEL_CLEAN_REQUEST = 'TERMINAL_MODEL_CLEAN_REQUEST';
export const TERMINAL_LOCATION_EVENT_CLEAN_REQUEST = 'TERMINAL_LOCATION_EVENT_CLEAN_REQUEST';
export const TERMINAL_MODEL_FIELD_FILTER_CLEAN_REQUEST =
  'TERMINAL_MODEL_FIELD_FILTER_CLEAN_REQUEST';

// Terminal Logs actions
export const TERMINAL_LOGS_FIELD_FILTER_REQUEST = 'TERMINAL_LOGS_FIELD_FILTER_REQUEST';
export const TERMINAL_LOGS_FIELD_FILTER_REQUEST_SUCCESS =
  'TERMINAL_LOGS_FIELD_FILTER_REQUEST_SUCCESS';
export const TERMINAL_LOGS_FIELD_FILTER_REQUEST_FAILURE =
  'TERMINAL_LOGS_FIELD_FILTER_REQUEST_FAILURE';
export const TERMINAL_LOGS_FETCH_REQUEST = 'TERMINAL_LOGS_FETCH_REQUEST';
export const TERMINAL_LOGS_FETCH_REQUEST_SUCCESS = 'TERMINAL_LOGS_FETCH_REQUEST_SUCCESS';
export const TERMINAL_LOGS_FETCH_REQUEST_FAILURE = 'TERMINAL_LOGS_FETCH_REQUEST_FAILURE';
export const TERMINAL_LOGS_CLEAN_REQUEST = 'TERMINAL_LOGS_CLEAN_REQUEST';

export const PLATFORM_CERTIFICATE_ADD_REQUEST = 'PLATFORM_CERTIFICATE_ADD_REQUEST';
export const PLATFORM_CERTIFICATE_ADD_REQUEST_SUCCESS = 'PLATFORM_CERTIFICATE_ADD_REQUEST_SUCCESS';
export const PLATFORM_CERTIFICATE_ADD_REQUEST_FAILURE = 'PLATFORM_CERTIFICATE_ADD_REQUEST_FAILURE';

export const PLATFORM_CERTIFICATE_FETCH_REQUEST = 'PLATFORM_CERTIFICATE_FETCH_REQUEST';
export const PLATFORM_CERTIFICATE_FETCH_REQUEST_SUCCESS =
  'PLATFORM_CERTIFICATE_FETCH_REQUEST_SUCCESS';
export const PLATFORM_CERTIFICATE_FETCH_REQUEST_FAILURE =
  'PLATFORM_CERTIFICATE_FETCH_REQUEST_FAILURE';

export const PLATFORM_CERTIFICATE_UPDATE_REQUEST = 'PLATFORM_CERTIFICATE_UPDATE_REQUEST';
export const PLATFORM_CERTIFICATE_UPDATE_REQUEST_SUCCESS =
  'PLATFORM_CERTIFICATE_UPDATE_REQUEST_SUCCESS';
export const PLATFORM_CERTIFICATE_UPDATE_REQUEST_FAILURE =
  'PLATFORM_CERTIFICATE_UPDATE_REQUEST_FAILURE';

export const PLATFORM_CERTIFICATE_FIELD_FILTER_REQUEST =
  'PLATFORM_CERTIFICATE_FIELD_FILTER_REQUEST';
export const PLATFORM_CERTIFICATE_FIELD_FILTER_REQUEST_SUCCESS =
  'PLATFORM_CERTIFICATE_FIELD_FILTER_REQUEST_SUCCESS';
export const PLATFORM_CERTIFICATE_FIELD_FILTER_REQUEST_FAILURE =
  'PLATFORM_CERTIFICATE_FILTER_REQUEST_FAILURE';

export const PLATFORM_CERTIFICATE_CLEAN_REQUEST = 'PLATFORM_CERTIFICATE_CLEAN_REQUEST';
export const PLATFORM_CERTIFICATE_FIELD_FILTER_CLEAN_REQUEST =
  'PLATFORM_CERTIFICATE_FIELD_FILTER_CLEAN_REQUEST';

export const FIRMWARE_ADD_REQUEST = 'FIRMWARE_ADD_REQUEST';
export const FIRMWARE_ADD_REQUEST_SUCCESS = 'FIRMWARE_ADD_REQUEST_SUCCESS';
export const FIRMWARE_ADD_REQUEST_FAILURE = 'FIRMWARE_ADD_REQUEST_FAILURE';

export const FIRMWARE_FETCH_REQUEST = 'FIRMWARE_FETCH_REQUEST';
export const FIRMWARE_FETCH_REQUEST_SUCCESS = 'FIRMWARE_FETCH_REQUEST_SUCCESS';
export const FIRMWARE_FETCH_REQUEST_FAILURE = 'FIRMWARE_FETCH_REQUEST_FAILURE';

export const FIRMWARE_UPDATE_REQUEST = 'FIRMWARE_UPDATE_REQUEST';
export const FIRMWARE_UPDATE_REQUEST_SUCCESS = 'FIRMWARE_UPDATE_REQUEST_SUCCESS';
export const FIRMWARE_UPDATE_REQUEST_FAILURE = 'FIRMWARE_UPDATE_REQUEST_FAILURE';

export const FIRMWARE_FIELD_FILTER_REQUEST = 'FIRMWARE_FIELD_FILTER_REQUEST';
export const FIRMWARE_FIELD_FILTER_REQUEST_SUCCESS = 'FIRMWARE_FIELD_FILTER_REQUEST_SUCCESS';
export const FIRMWARE_FIELD_FILTER_REQUEST_FAILURE = 'FIRMWARE_FILTER_REQUEST_FAILURE';

export const FIRMWARE_CLEAN_REQUEST = 'FIRMWARE_CLEAN_REQUEST';
export const FIRMWARE_FIELD_FILTER_CLEAN_REQUEST = 'FIRMWARE_FIELD_FILTER_CLEAN_REQUEST';

export const ENTITY_SUMMARY_FETCH_REQUEST = 'ENTITY_SUMMARY_FETCH_REQUEST';
export const ENTITY_SUMMARY_FETCH_REQUEST_SUCCESS = 'ENTITY_SUMMARY_FETCH_REQUEST_SUCCESS';
export const ENTITY_SUMMARY_FETCH_REQUEST_FAILURE = 'ENTITY_SUMMARY_FETCH_REQUEST_FAILURE';

export const ENTITY_SUMMARY_CLEAN_REQUEST = 'ENTITY_SUMMARY_CLEAN_REQUEST';

export const CUSTOMER_FETCH_REQUEST = 'CUSTOMER_FETCH_REQUEST';
export const CUSTOMER_FETCH_REQUEST_SUCCESS = 'CUSTOMER_FETCH_REQUEST_SUCCESS';
export const CUSTOMER_FETCH_REQUEST_FAILURE = 'CUSTOMER_FETCH_REQUEST_FAILURE';

export const CUSTOMER_UPDATE_REQUEST = 'CUSTOMER_UPDATE_REQUEST';
export const CUSTOMER_UPDATE_REQUEST_SUCCESS = 'CUSTOMER_UPDATE_REQUEST_SUCCESS';
export const CUSTOMER_UPDATE_REQUEST_FAILURE = 'CUSTOMER_UPDATE_REQUEST_FAILURE';

export const CUSTOMER_FIELD_FILTER_REQUEST = 'CUSTOMER_FIELD_FILTER_REQUEST';
export const CUSTOMER_FIELD_FILTER_REQUEST_SUCCESS = 'CUSTOMER_FIELD_FILTER_REQUEST_SUCCESS';
export const CUSTOMER_FIELD_FILTER_REQUEST_FAILURE = 'CUSTOMER_FIELD_FILTER_REQUEST_FAILURE';

export const CUSTOMER_PRODUCT_TYPE_FETCH_REQUEST = 'CUSTOMER_PRODUCT_TYPE_FETCH_REQUEST';
export const CUSTOMER_PRODUCT_TYPE_FETCH_REQUEST_SUCCESS =
  'CUSTOMER_PRODUCT_TYPE_FETCH_REQUEST_SUCCESS';
export const CUSTOMER_PRODUCT_TYPE_FETCH_REQUEST_FAILURE =
  'CUSTOMER_PRODUCT_TYPE_FETCH_REQUEST_FAILURE';

export const CUSTOMER_ACCOUNT_TYPE_FETCH_REQUEST = 'CUSTOMER_ACCOUNT_TYPE_FETCH_REQUEST';
export const CUSTOMER_ACCOUNT_TYPE_FETCH_REQUEST_SUCCESS =
  'CUSTOMER_ACCOUNT_TYPE_FETCH_REQUEST_SUCCESS';
export const CUSTOMER_ACCOUNT_TYPE_FETCH_REQUEST_FAILURE =
  'CUSTOMER_ACCOUNT_TYPE_FETCH_REQUEST_FAILURE';

export const CUSTOMER_CLEAN_REQUEST = 'CUSTOMER_CLEAN_REQUEST';
export const CUSTOMER_PRODUCT_TYPE_CLEAN_REQUEST = 'CUSTOMER_PRODUCT_TYPE_CLEAN_REQUEST';
export const CUSTOMER_ACCOUNT_TYPE_CLEAN_REQUEST = 'CUSTOMER_ACCOUNT_TYPE_CLEAN_REQUEST';
export const CUSTOMER_FIELD_FILTER_CLEAN_REQUEST = 'CUSTOMER_FIELD_FILTER_CLEAN_REQUEST';

export const CUSTOMER_ENROLLMENT_FETCH_REQUEST = 'CUSTOMER_ENROLLMENT_FETCH_REQUEST';
export const CUSTOMER_ENROLLMENT_FETCH_REQUEST_SUCCESS =
  'CUSTOMER_ENROLLMENT_FETCH_REQUEST_SUCCESS';
export const CUSTOMER_ENROLLMENT_FETCH_REQUEST_FAILURE =
  'CUSTOMER_ENROLLMENT_FETCH_REQUEST_FAILURE';
export const CUSTOMER_ENROLLMENT_CLEAN_REQUEST = 'CUSTOMER_ENROLLMENT_CLEAN_REQUEST';
export const CUSTOMER_ENROLLMENT_REPORT_FIELD_FILTER_CLEAN_REQUEST =
  'CUSTOMER_ENROLLMENT_REPORT_FIELD_FILTER_CLEAN_REQUEST';

export const MTO_FETCH_REQUEST = 'MTO_FETCH_REQUEST';
export const MTO_FETCH_REQUEST_SUCCESS = 'MTO_FETCH_REQUEST_SUCCESS';
export const MTO_FETCH_REQUEST_FAILURE = 'MTO_FETCH_REQUEST_FAILURE';

export const MTO_FIELD_FILTER_REQUEST = 'MTO_FIELD_FILTER_REQUEST';
export const MTO_FIELD_FILTER_REQUEST_SUCCESS = 'MTO_FIELD_FILTER_REQUEST_SUCCESS';
export const MTO_FIELD_FILTER_REQUEST_FAILURE = 'MTO_FIELD_FILTER_REQUEST_FAILURE';

export const MTO_ADD_REQUEST = 'MTO_ADD_REQUEST';
export const MTO_ADD_REQUEST_SUCCESS = 'MTO_ADD_REQUEST_SUCCESS';
export const MTO_ADD_REQUEST_FAILURE = 'MTO_ADD_REQUEST_FAILURE';

export const MTO_UPDATE_REQUEST = 'MTO_UPDATE_REQUEST';
export const MTO_UPDATE_REQUEST_SUCCESS = 'MTO_UPDATE_REQUEST_SUCCESS';
export const MTO_UPDATE_REQUEST_FAILURE = 'MTO_UPDATE_REQUEST_FAILURE';

export const MTO_CLEAN_REQUEST = 'MTO_CLEAN_REQUEST';
export const MTO_FIELD_FILTER_CLEAN_REQUEST = 'MTO_FIELD_FILTER_CLEAN_REQUEST';

export const COUNTRY_FETCH_REQUEST = 'COUNTRY_FETCH_REQUEST';
export const COUNTRY_FETCH_REQUEST_SUCCESS = 'COUNTRY_FETCH_REQUEST_SUCCESS';
export const COUNTRY_FETCH_REQUEST_FAILURE = 'COUNTRY_FETCH_REQUEST_FAILURE';

export const COUNTRY_CLEAN_REQUEST = 'COUNTRY_CLEAN_REQUEST';

export const MESSAGING_FETCH_REQUEST = 'MESSAGING_FETCH_REQUEST';
export const MESSAGING_FETCH_REQUEST_SUCCESS = 'MESSAGING_FETCH_REQUEST_SUCCESS';
export const MESSAGING_FETCH_REQUEST_FAILURE = 'MESSAGING_FETCH_REQUEST_FAILURE';

export const MESSAGING_FIELD_FILTER_REQUEST = 'MESSAGING_FIELD_FILTER_REQUEST';
export const MESSAGING_FIELD_FILTER_REQUEST_SUCCESS = 'MESSAGING_FIELD_FILTER_REQUEST_SUCCESS';
export const MESSAGING_FIELD_FILTER_REQUEST_FAILURE = 'MESSAGING_FIELD_FILTER_REQUEST_FAILURE';

export const MESSAGING_ADD_REQUEST = 'MESSAGING_ADD_REQUEST';
export const MESSAGING_ADD_REQUEST_SUCCESS = 'MESSAGING_ADD_REQUEST_SUCCESS';
export const MESSAGING_ADD_REQUEST_FAILURE = 'MESSAGING_ADD_REQUEST_FAILURE';

export const MESSAGING_UPDATE_REQUEST = 'MESSAGING_UPDATE_REQUEST';
export const MESSAGING_UPDATE_REQUEST_SUCCESS = 'MESSAGING_UPDATE_REQUEST_SUCCESS';
export const MESSAGING_UPDATE_REQUEST_FAILURE = 'MESSAGING_UPDATE_REQUEST_FAILURE';

export const MESSAGING_PARAMETER_TYPE_FETCH_REQUEST = 'MESSAGING_PARAMETER_TYPE_FETCH_REQUEST';
export const MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_SUCCESS =
  'MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_SUCCESS';
export const MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_FAILURE =
  'MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_FAILURE';

export const MESSAGING_CLEAN_REQUEST = 'MESSAGING_CLEAN_REQUEST';
export const MESSAGING_FIELD_FILTER_CLEAN_REQUEST = 'MESSAGING_FIELD_FILTER_CLEAN_REQUEST';
export const MESSAGING_PARAMETER_TYPE_CLEAN_REQUEST = 'MESSAGING_PARAMETER_TYPE_CLEAN_REQUEST';

export const APP_FETCH_REQUEST = 'APP_FETCH_REQUEST';
export const APP_FETCH_REQUEST_SUCCESS = 'APP_FETCH_REQUEST_SUCCESS';
export const APP_FETCH_REQUEST_FAILURE = 'APP_FETCH_REQUEST_FAILURE';

export const APP_ADD_REQUEST = 'APP_ADD_REQUEST';
export const APP_ADD_REQUEST_SUCCESS = 'APP_ADD_REQUEST_SUCCESS';
export const APP_ADD_REQUEST_FAILURE = 'APP_ADD_REQUEST_FAILURE';

export const APP_UPDATE_REQUEST = 'APP_UPDATE_REQUEST';
export const APP_UPDATE_REQUEST_SUCCESS = 'APP_UPDATE_REQUEST_SUCCESS';
export const APP_UPDATE_REQUEST_FAILURE = 'APP_UPDATE_REQUEST_FAILURE';

export const APP_FIELD_FILTER_REQUEST = 'APP_FIELD_FILTER_REQUEST';
export const APP_FIELD_FILTER_REQUEST_SUCCESS = 'APP_FIELD_FILTER_REQUEST_SUCCESS';
export const APP_FIELD_FILTER_REQUEST_FAILURE = 'APP_FIELD_FILTER_REQUEST_FAILURE';

export const APP_CLEAN_REQUEST = 'APP_CLEAN_REQUEST';
export const APP_FIELD_FILTER_CLEAN_REQUEST = 'APP_FIELD_FILTER_CLEAN_REQUEST';

export const APP_CATEGORY_IMPORT_REQUEST = 'APP_CATEGORY_IMPORT_REQUEST';
export const APP_CATEGORY_IMPORT_REQUEST_SUCCESS = 'APP_CATEGORY_IMPORT_REQUEST_SUCCESS';
export const APP_CATEGORY_IMPORT_REQUEST_FAILURE = 'APP_CATEGORY_IMPORT_REQUEST_FAILURE';

export const APP_CATEGORY_CHART_FETCH_REQUEST = 'APP_CATEGORY_CHART_FETCH_REQUEST';
export const APP_CATEGORY_CHART_FETCH_REQUEST_SUCCESS = 'APP_CATEGORY_CHART_FETCH_REQUEST_SUCCESS';
export const APP_CATEGORY_CHART_FETCH_REQUEST_FAILURE = 'APP_CATEGORY_CHART_FETCH_REQUEST_FAILURE';

export const APP_CATEGORY_CHART_CLEAN_REQUEST = 'APP_CATEGORY_CHART_CLEAN_REQUEST';

export const APP_BROADCAST_ADD_REQUEST = 'APP_BROADCAST_ADD_REQUEST';
export const APP_BROADCAST_ADD_REQUEST_SUCCESS = 'APP_BROADCAST_ADD_REQUEST_SUCCESS';
export const APP_BROADCAST_ADD_REQUEST_FAILURE = 'APP_BROADCAST_ADD_REQUEST_FAILURE';

export const APP_BROADCAST_UPDATE_REQUEST = 'APP_BROADCAST_UPDATE_REQUEST';
export const APP_BROADCAST_UPDATE_REQUEST_SUCCESS = 'APP_BROADCAST_UPDATE_REQUEST_SUCCESS';
export const APP_BROADCAST_UPDATE_REQUEST_FAILURE = 'APP_BROADCAST_UPDATE_REQUEST_FAILURE';

export const APP_BROADCAST_CLEAN_REQUEST = 'APP_BROADCAST_CLEAN_REQUEST';

export const CHANNEL_FETCH_REQUEST = 'CHANNEL_FETCH_REQUEST';
export const CHANNEL_FETCH_REQUEST_SUCCESS = 'CHANNEL_FETCH_REQUEST_SUCCESS';
export const CHANNEL_FETCH_REQUEST_FAILURE = 'CHANNEL_FETCH_REQUEST_FAILURE';

export const CHANNEL_ADD_REQUEST = 'CHANNEL_ADD_REQUEST';
export const CHANNEL_ADD_REQUEST_SUCCESS = 'CHANNEL_ADD_REQUEST_SUCCESS';
export const CHANNEL_ADD_REQUEST_FAILURE = 'CHANNEL_ADD_REQUEST_FAILURE';

export const CHANNEL_UPDATE_REQUEST = 'CHANNEL_UPDATE_REQUEST';
export const CHANNEL_UPDATE_REQUEST_SUCCESS = 'CHANNEL_UPDATE_REQUEST_SUCCESS';
export const CHANNEL_UPDATE_REQUEST_FAILURE = 'CHANNEL_UPDATE_REQUEST_FAILURE';

export const CHANNEL_FIELD_FILTER_REQUEST = 'CHANNEL_FIELD_FILTER_REQUEST';
export const CHANNEL_FIELD_FILTER_REQUEST_SUCCESS = 'CHANNEL_FIELD_FILTER_REQUEST_SUCCESS';
export const CHANNEL_FIELD_FILTER_REQUEST_FAILURE = 'CHANNEL_FIELD_FILTER_REQUEST_FAILURE';

export const CHANNEL_TYPE_FETCH_REQUEST = 'CHANNEL_TYPE_FETCH_REQUEST';
export const CHANNEL_TYPE_FETCH_REQUEST_SUCCESS = 'CHANNEL_TYPE_FETCH_REQUEST_SUCCESS';
export const CHANNEL_TYPE_FETCH_REQUEST_FAILURE = 'CHANNEL_TYPE_FETCH_REQUEST_FAILURE';

export const METHOD_TYPE_FETCH_REQUEST = 'METHOD_TYPE_FETCH_REQUEST';
export const METHOD_TYPE_FETCH_REQUEST_SUCCESS = 'METHOD_TYPE_FETCH_REQUEST_SUCCESS';
export const METHOD_TYPE_FETCH_REQUEST_FAILURE = 'METHOD_TYPE_FETCH_REQUEST_FAILURE';

export const TRANSACTION_RESTRICTION_TYPE_FETCH_REQUEST =
  'TRANSACTION_RESTRICTION_TYPE_FETCH_REQUEST';
export const TRANSACTION_RESTRICTION_TYPE_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_RESTRICTION_TYPE_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_RESTRICTION_TYPE_FETCH_REQUEST_FAILURE =
  'TRANSACTION_RESTRICTION_TYPE_FETCH_REQUEST_FAILURE';

export const ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST =
  'ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST';
export const ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_SUCCESS =
  'ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_SUCCESS';
export const ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_FAILURE =
  'ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_FAILURE';

export const TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST = 'TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST';
export const TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_FAILURE =
  'TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_FAILURE';

export const CHANNEL_CLEAN_REQUEST = 'CHANNEL_CLEAN_REQUEST';
export const CHANNEL_FIELD_FILTER_CLEAN_REQUEST = 'CHANNEL_FIELD_FILTER_CLEAN_REQUEST';

export const SWITCH_FETCH_REQUEST = 'SWITCH_FETCH_REQUEST';
export const SWITCH_FETCH_REQUEST_SUCCESS = 'SWITCH_FETCH_REQUEST_SUCCESS';
export const SWITCH_FETCH_REQUEST_FAILURE = 'SWITCH_FETCH_REQUEST_FAILURE';

export const SWITCH_ADD_REQUEST = 'SWITCH_ADD_REQUEST';
export const SWITCH_ADD_REQUEST_SUCCESS = 'SWITCH_ADD_REQUEST_SUCCESS';
export const SWITCH_ADD_REQUEST_FAILURE = 'SWITCH_ADD_REQUEST_FAILURE';

export const SWITCH_FIELD_FILTER_REQUEST = 'SWITCH_FIELD_FILTER_REQUEST';
export const SWITCH_FIELD_FILTER_REQUEST_SUCCESS = 'SWITCH_FIELD_FILTER_REQUEST_SUCCESS';
export const SWITCH_FIELD_FILTER_REQUEST_FAILURE = 'SWITCH_FIELD_FILTER_REQUEST_FAILURE';

export const SWITCH_UPDATE_REQUEST = 'SWITCH_UPDATE_REQUEST';
export const SWITCH_UPDATE_REQUEST_SUCCESS = 'SWITCH_UPDATE_REQUEST_SUCCESS';
export const SWITCH_UPDATE_REQUEST_FAILURE = 'SWITCH_UPDATE_REQUEST_FAILURE';

export const SWITCH_CLEAN_REQUEST = 'SWITCH_CLEAN_REQUEST';
export const SWITCH_FIELD_FILTER_CLEAN_REQUEST = 'SWITCH_FIELD_FILTER_CLEAN_REQUEST';

export const SWITCH_TYPE_FETCH_REQUEST = 'SWITCH_TYPE_FETCH_REQUEST';
export const SWITCH_TYPE_FETCH_REQUEST_SUCCESS = 'SWITCH_TYPE_FETCH_REQUEST_SUCCESS';
export const SWITCH_TYPE_FETCH_REQUEST_FAILURE = 'SWITCH_TYPE_FETCH_REQUEST_FAILURE';

export const SWITCH_TYPE_CLEAN_REQUEST = 'SWITCH_TYPE_CLEAN_REQUEST';

export const SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST = 'SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST';
export const SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_SUCCESS =
  'SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_SUCCESS';
export const SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_FAILURE =
  'SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_FAILURE';

export const SWITCH_KEY_ENCRYPTION_TYPE_CLEAN_REQUEST = 'SWITCH_KEY_ENCRYPTION_TYPE_CLEAN_REQUEST';

export const SWITCH_CERTIFICATE_FACTORY_TYPE_FETCH_REQUEST =
  'SWITCH_CERTIFICATE_FACTORY_TYPE_FETCH_REQUEST';
export const SWITCH_CERTIFICATE_FACTORY_TYPE_FETCH_REQUEST_SUCCESS =
  'SWITCH_CERTIFICATE_FACTORY_TYPE_FETCH_REQUEST_SUCCESS';
export const SWITCH_CERTIFICATE_FACTORY_TYPE_FETCH_REQUEST_FAILURE =
  'SWITCH_CERTIFICATE_FACTORY_TYPE_FETCH_REQUEST_FAILURE';

export const SWITCH_CERTIFICATE_FACTORY_TYPE_CLEAN_REQUEST =
  'SWITCH_CERTIFICATE_FACTORY_TYPE_CLEAN_REQUEST';

export const SWITCH_CERTIFICATE_VERSIONS_FETCH_REQUEST =
  'SWITCH_CERTIFICATE_VERSIONS_FETCH_REQUEST';
export const SWITCH_CERTIFICATE_VERSIONS_FETCH_REQUEST_SUCCESS =
  'SWITCH_CERTIFICATE_VERSIONS_FETCH_REQUEST_SUCCESS';
export const SWITCH_CERTIFICATE_VERSIONS_FETCH_REQUEST_FAILURE =
  'SWITCH_CERTIFICATE_VERSIONS_FETCH_REQUEST_FAILURE';

export const SWITCH_CERTIFICATE_VERSIONS_CLEAN_REQUEST =
  'SWITCH_CERTIFICATE_VERSIONS_CLEAN_REQUEST';

export const INTEGRATION_CODE_FETCH_REQUEST = 'INTEGRATION_CODE_FETCH_REQUEST';
export const INTEGRATION_CODE_TYPE_FETCH_REQUEST_SUCCESS =
  'INTEGRATION_CODE_TYPE_FETCH_REQUEST_SUCCESS';
export const INTEGRATION_CODE_TYPE_FETCH_REQUEST_FAILURE =
  'INTEGRATION_CODE_TYPE_FETCH_REQUEST_FAILURE';
export const INTEGRATION_CODE_TYPE_CLEAN_REQUEST = 'INTEGRATION_CODE_TYPE_CLEAN_REQUEST';

export const TRANSACTION_COUNT_FETCH_REQUEST = 'TRANSACTION_COUNT_FETCH_REQUEST';
export const TRANSACTION_COUNT_FETCH_REQUEST_SUCCESS = 'TRANSACTION_COUNT_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_COUNT_FETCH_REQUEST_FAILURE = 'TRANSACTION_COUNT_FETCH_REQUEST_FAILURE';

export const TRANSACTION_SUMMARY_FETCH_REQUEST = 'TRANSACTION_SUMMARY_FETCH_REQUEST';
export const TRANSACTION_SUMMARY_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_SUMMARY_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_SUMMARY_FETCH_REQUEST_FAILURE =
  'TRANSACTION_SUMMARY_FETCH_REQUEST_FAILURE';

export const TRANSACTION_COUNT_CLEAN_REQUEST = 'TRANSACTION_COUNT_CLEAN_REQUEST';
export const TRANSACTION_SUMMARY_CLEAN_REQUEST = 'TRANSACTION_SUMMARY_CLEAN_REQUEST';

export const APP_CHART_FETCH_REQUEST = 'APP_CHART_FETCH_REQUEST';
export const APP_CHART_FETCH_REQUEST_SUCCESS = 'APP_CHART_FETCH_REQUEST_SUCCESS';
export const APP_CHART_FETCH_REQUEST_FAILURE = 'APP_CHART_FETCH_REQUEST_FAILURE';
export const APP_REPORT_FETCH_REQUEST = 'APP_REPORT_FETCH_REQUEST';
export const APP_REPORT_FETCH_REQUEST_SUCCESS = 'APP_REPORT_FETCH_REQUEST_SUCCESS';
export const APP_REPORT_FETCH_REQUEST_FAILURE = 'APP_REPORT_FETCH_REQUEST_FAILURE';
export const APP_REPORT_FILTER_FIELD_REQUEST = 'APP_REPORT_FILTER_FIELD_REQUEST';
export const APP_REPORT_FILTER_FIELD_REQUEST_SUCCESS = 'APP_REPORT_FILTER_FIELD_REQUEST_SUCCESS';
export const APP_REPORT_FILTER_FIELD_REQUEST_FAILURE = 'APP_REPORT_FILTER_FIELD_REQUEST_FAILURE';
export const APP_REPORT_DETAIL_FETCH_REQUEST = 'APP_REPORT_DETAIL_FETCH_REQUEST';
export const APP_REPORT_DETAIL_FETCH_REQUEST_SUCCESS = 'APP_REPORT_DETAIL_FETCH_REQUEST_SUCCESS';
export const APP_REPORT_DETAIL_FETCH_REQUEST_FAILURE = 'APP_REPORT_DETAIL_FETCH_REQUEST_FAILURE';
export const APP_CHART_CLEAN_REQUEST = 'APP_CHART_CLEAN_REQUEST';
export const APP_REPORT_CLEAN_REQUEST = 'APP_REPORT_CLEAN_REQUEST';
export const APP_REPORT_DETAIL_CLEAN_REQUEST = 'APP_REPORT_DETAIL_CLEAN_REQUEST';
export const APP_REPORT_FILTER_FIELD_CLEAN_REQUEST = 'APP_REPORT_FILTER_FIELD_CLEAN_REQUEST';

// compliance
export const COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST = 'COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST';
export const COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_SUCCESS =
  'COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_SUCCESS';
export const COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_FAILURE =
  'COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_FAILURE';

export const COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST = 'COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST';
export const COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_SUCCESS =
  'COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_SUCCESS';
export const COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_FAILURE =
  'COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_FAILURE';

export const COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST = 'COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST';
export const COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_SUCCESS =
  'COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_SUCCESS';
export const COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_FAILURE =
  'COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_FAILURE';

export const COMPLIANCE_CLEAN_REQUEST = 'COMPLIANCE_CLEAN_REQUEST';
export const COMPLIANCE_INTERNAL_BLOCK_CLEAN_REQUEST = 'COMPLIANCE_INTERNAL_BLOCK_CLEAN_REQUEST';
export const REMIT_INFO_CLEAN_REQUEST = 'REMIT_INFO_CLEAN_REQUEST';

export const COMPLIANCE_ADD_REQUEST = 'COMPLIANCE_ADD_REQUEST';
export const COMPLIANCE_ADD_REQUEST_SUCCESS = 'COMPLIANCE_ADD_REQUEST_SUCCESS';
export const COMPLIANCE_ADD_REQUEST_FAILURE = 'COMPLIANCE_ADD_REQUEST_FAILURE';

export const COMPLIANCE_UPDATE_REQUEST = 'COMPLIANCE_UPDATE_REQUEST';
export const COMPLIANCE_UPDATE_REQUEST_SUCCESS = 'COMPLIANCE_UPDATE_REQUEST_SUCCESS';
export const COMPLIANCE_UPDATE_REQUEST_FAILURE = 'COMPLIANCE_UPDATE_REQUEST_FAILURE';

export const COMPLIANCE_FETCH_REQUEST = 'COMPLIANCE_FETCH_REQUEST';
export const COMPLIANCE_FETCH_REQUEST_SUCCESS = 'COMPLIANCE_FETCH_REQUEST_SUCCESS';
export const COMPLIANCE_FETCH_REQUEST_FAILURE = 'COMPLIANCE_FETCH_REQUEST_FAILURE';

export const COMPLIANCE_VERSION_FETCH_REQUEST = 'COMPLIANCE_VERSION_FETCH_REQUEST';
export const COMPLIANCE_VERSION_FETCH_REQUEST_SUCCESS = 'COMPLIANCE_VERSION_FETCH_REQUEST_SUCCESS';
export const COMPLIANCE_VERSION_FETCH_REQUEST_FAILURE = 'COMPLIANCE_VERSION_FETCH_REQUEST_FAILURE';

export const COMPLIANCE_REMITTER_VERSION_FETCH_REQUEST_SUCCESS =
  'COMPLIANCE_REMITTER_VERSION_FETCH_REQUEST_SUCCESS';
export const COMPLIANCE_REMITTER_VERSION_FETCH_REQUEST_FAILURE =
  'COMPLIANCE_REMITTER_VERSION_FETCH_REQUEST_FAILURE';
export const COMPLIANCE_BENEFICIARY_VERSION_FETCH_REQUEST_SUCCESS =
  'COMPLIANCE_BENEFICIARY_VERSION_FETCH_REQUEST_SUCCESS';
export const COMPLIANCE_BENEFICIARY_VERSION_FETCH_REQUEST_FAILURE =
  'COMPLIANCE_BENEFICIARY_VERSION_FETCH_REQUEST_FAILURE';

export const REMIT_INFO_FETCH_REQUEST = 'REMIT_INFO_FETCH_REQUEST';
export const REMIT_INFO_REMITTER_FETCH_REQUEST_SUCCESS =
  'REMIT_INFO_REMITTER_FETCH_REQUEST_SUCCESS';
export const REMIT_INFO_BENEFICIARY_FETCH_REQUEST_SUCCESS =
  'REMIT_INFO_BENEFICIARY_FETCH_REQUEST_SUCCESS';
export const REMIT_INFO_FETCH_REQUEST_FAILURE = 'REMIT_INFO_FETCH_REQUEST_FAILURE';

// currency
export const CURRENCY_CLEAN_REQUEST = 'CURRENCY_CLEAN_REQUEST';

export const CURRENCY_ADD_REQUEST = 'CURRENCY_ADD_REQUEST';
export const CURRENCY_ADD_REQUEST_SUCCESS = 'CURRENCY_ADD_REQUEST_SUCCESS';
export const CURRENCY_ADD_REQUEST_FAILURE = 'CURRENCY_ADD_REQUEST_FAILURE';

export const CURRENCY_UPDATE_REQUEST = 'CURRENCY_UPDATE_REQUEST';
export const CURRENCY_UPDATE_REQUEST_SUCCESS = 'CURRENCY_UPDATE_REQUEST_SUCCESS';
export const CURRENCY_UPDATE_REQUEST_FAILURE = 'CURRENCY_UPDATE_REQUEST_FAILURE';

export const CURRENCY_FETCH_REQUEST = 'CURRENCY_FETCH_REQUEST';
export const CURRENCY_FETCH_REQUEST_SUCCESS = 'CURRENCY_FETCH_REQUEST_SUCCESS';
export const CURRENCY_FETCH_REQUEST_FAILURE = 'CURRENCY_FETCH_REQUEST_FAILURE';

// draft
export const DRAFT_STATUS_CLEAN_REQUEST = 'DRAFT_STATUS_CLEAN_REQUEST';

export const DRAFT_STATUS_FETCH_REQUEST = 'DRAFT_STATUS_FETCH_REQUEST';
export const DRAFT_STATUS_FETCH_REQUEST_SUCCESS = 'DRAFT_STATUS_FETCH_REQUEST_SUCCESS';
export const DRAFT_STATUS_FETCH_REQUEST_FAILURE = 'DRAFT_STATUS_FETCH_REQUEST_FAILURE';

export const DRAFT_STATUS_ADD_REQUEST = 'DRAFT_STATUS_ADD_REQUEST';
export const DRAFT_STATUS_ADD_REQUEST_SUCCESS = 'DRAFT_STATUS_ADD_REQUEST_SUCCESS';
export const DRAFT_STATUS_ADD_REQUEST_FAILURE = 'DRAFT_STATUS_ADD_REQUEST_FAILURE';

// filter field
export const FILTER_FIELD_CLEAN_REQUEST = 'FILTER_FIELD_CLEAN_REQUEST';

export const FILTER_FIELD_FETCH_REQUEST = 'FILTER_FIELD_FETCH_REQUEST';
export const FILTER_FIELD_FETCH_REQUEST_SUCCESS = 'FILTER_FIELD_FETCH_REQUEST_SUCCESS';
export const FILTER_FIELD_FETCH_REQUEST_FAILURE = 'FILTER_FIELD_FETCH_REQUEST_FAILURE';

// List
export const LIST_CLEAN_REQUEST = 'LIST_CLEAN_REQUEST';

export const LIST_FETCH_REQUEST = 'LIST_FETCH_REQUEST';
export const LIST_FETCH_REQUEST_SUCCESS = 'LIST_FETCH_REQUEST_SUCCESS';
export const LIST_FETCH_REQUEST_FAILURE = 'LIST_FETCH_REQUEST_FAILURE';

// master
export const MASTER_CLEAN_REQUEST = 'MASTER_CLEAN_REQUEST';

export const MASTER_COMMISSION_SOURCE_FETCH_REQUEST = ' MASTER_COMMISSION_SOURCE_FETCH_REQUEST';
export const MASTER_COMMISSION_SOURCE_FETCH_REQUEST_SUCCESS =
  ' MASTER_COMMISSION_SOURCE_FETCH_REQUEST_SUCCESS';
export const MASTER_COMMISSION_SOURCE_FETCH_REQUEST_FAILURE =
  ' MASTER_COMMISSION_SOURCE_FETCH_REQUEST_FAILURE';

export const MASTER_FETCH_REQUEST = 'MASTER_FETCH_REQUEST';
export const MASTER_FETCH_REQUEST_SUCCESS = 'MASTER_FETCH_REQUEST_SUCCESS';
export const MASTER_FETCH_REQUEST_FAILURE = 'MASTER_FETCH_REQUEST_FAILURE';

// partner
export const PARTNER_CLEAN_REQUEST = 'PARTNER_CLEAN_REQUEST';

export const PARTNER_ADD_REQUEST = 'PARTNER_ADD_REQUEST';
export const PARTNER_ADD_REQUEST_SUCCESS = 'PARTNER_ADD_REQUEST_SUCCESS';
export const PARTNER_ADD_REQUEST_FAILURE = 'PARTNER_ADD_REQUEST_FAILURE';

export const PARTNER_UPDATE_REQUEST = 'PARTNER_UPDATE_REQUEST';
export const PARTNER_UPDATE_REQUEST_SUCCESS = 'PARTNER_UPDATE_REQUEST_SUCCESS';
export const PARTNER_UPDATE_REQUEST_FAILURE = 'PARTNER_UPDATE_REQUEST_FAILURE';

export const PARTNER_FETCH_REQUEST = 'PARTNER_FETCH_REQUEST';
export const PARTNER_FETCH_REQUEST_SUCCESS = 'PARTNER_FETCH_REQUEST_SUCCESS';
export const PARTNER_FETCH_REQUEST_FAILURE = 'PARTNER_FETCH_REQUEST_FAILURE';

// reject
export const REJECTED_CLEAN_REQUEST = 'REJECTED_CLEAN_REQUEST';

export const REJECTED_FETCH_REQUEST = 'REJECTED_FETCH_REQUEST';
export const REJECTED_FETCH_REQUEST_SUCCESS = 'REJECTED_FETCH_REQUEST_SUCCESS';
export const REJECTED_FETCH_REQUEST_FAILURE = 'REJECTED_FETCH_REQUEST_FAILURE';

// sanction
export const SANCTION_CLEAN_REQUEST = 'SANCTION_CLEAN_REQUEST';
export const SINGLE_SANCTION_CLEAN_REQUEST = 'SINGLE_SANCTION_CLEAN_REQUEST';

export const SANCTION_ADD_REQUEST = 'SANCTION_ADD_REQUEST';
export const SANCTION_ADD_REQUEST_SUCCESS = 'SANCTION_ADD_REQUEST_SUCCESS';
export const SANCTION_ADD_REQUEST_FAILURE = 'SANCTION_ADD_REQUEST_FAILURE';

export const SANCTION_FETCH_REQUEST = 'SANCTION_FETCH_REQUEST';
export const SANCTION_FETCH_REQUEST_SUCCESS = 'SANCTION_FETCH_REQUEST_SUCCESS';
export const SANCTION_FETCH_REQUEST_FAILURE = 'SANCTION_FETCH_REQUEST_FAILURE';

export const SANCTION_UPDATE_REQUEST = 'SANCTION_UPDATE_REQUEST';
export const SANCTION_UPDATE_REQUEST_SUCCESS = 'SANCTION_UPDATE_REQUEST_SUCCESS';
export const SANCTION_UPDATE_REQUEST_FAILURE = 'SANCTION_UPDATE_REQUEST_FAILURE';

export const SINGLE_SANCTION_FETCH_REQUEST = 'SINGLE_SANCTION_FETCH_REQUEST';
export const SINGLE_SANCTION_FETCH_REQUEST_SUCCESS = 'SINGLE_SANCTION_FETCH_REQUEST_SUCCESS';
export const SINGLE_SANCTION_FETCH_REQUEST_FAILURE = 'SINGLE_SANCTION_FETCH_REQUEST_FAILURE';

export const SANCTION_ASSOCIATE_CLEAN_REQUEST = 'SANCTION_ASSOCIATE_CLEAN_REQUEST';

export const SANCTION_ASSOCIATE_FETCH_REQUEST = 'SANCTION_ASSOCIATE_FETCH_REQUEST';
export const SANCTION_ASSOCIATE_FETCH_REQUEST_SUCCESS = 'SANCTION_ASSOCIATE_FETCH_REQUEST_SUCCESS';
export const SANCTION_ASSOCIATE_FETCH_REQUEST_FAILURE = 'SANCTION_ASSOCIATE_FETCH_REQUEST_FAILURE';

export const SANCTION_LIST_DETAIL_FETCH_REQUEST = 'SANCTION_LIST_DETAIL_FETCH_REQUEST';
export const SANCTION_LIST_DETAIL_FETCH_REQUEST_SUCCESS =
  'SANCTION_LIST_DETAIL_FETCH_REQUEST_SUCCESS';
export const SANCTION_LIST_DETAIL_FETCH_REQUEST_FAILURE =
  'SANCTION_LIST_DETAIL_FETCH_REQUEST_FAILURE';
export const SANCTION_LIST_DETAIL_CLEAN_REQUEST = 'SANCTION_LIST_DETAIL_CLEAN_REQUEST';

export const SANCTION_FIELDS_FETCH_REQUEST = 'SANCTION_FIELDS_FETCH_REQUEST';
export const SANCTION_FIELDS_FETCH_REQUEST_SUCCESS = 'SANCTION_FIELDS_FETCH_REQUEST_SUCCESS';
export const SANCTION_FIELDS_FETCH_REQUEST_FAILURE = 'SANCTION_FIELDS_FETCH_REQUEST_FAILURE';

// app builder
export const APP_BUILDER_FETCH_REQUEST = 'APP_BUILDER_FETCH_REQUEST';
export const APP_BUILDER_FETCH_REQUEST_SUCCESS = 'APP_BUILDER_FETCH_REQUEST_SUCCESS';
export const APP_BUILDER_FETCH_REQUEST_FAILURE = 'APP_BUILDER_FETCH_REQUEST_FAILURE';

export const APP_BUILDER_FIELD_FILTER_REQUEST = 'APP_BUILDER_FIELD_FILTER_REQUEST';
export const APP_BUILDER_FIELD_FILTER_REQUEST_SUCCESS = 'APP_BUILDER_FIELD_FILTER_REQUEST_SUCCESS';
export const APP_BUILDER_FIELD_FILTER_REQUEST_FAILURE = 'APP_BUILDER_FIELD_FILTER_REQUEST_FAILURE';

export const APP_BUILDER_ADD_REQUEST = 'APP_BUILDER_ADD_REQUEST';
export const APP_BUILDER_ADD_REQUEST_SUCCESS = 'APP_BUILDER_ADD_REQUEST_SUCCESS';
export const APP_BUILDER_ADD_REQUEST_FAILURE = 'APP_BUILDER_ADD_REQUEST_FAILURE';

export const APP_BUILDER_UPDATE_REQUEST = 'APP_BUILDER_UPDATE_REQUEST';
export const APP_BUILDER_UPDATE_REQUEST_SUCCESS = 'APP_BUILDER_UPDATE_REQUEST_SUCCESS';
export const APP_BUILDER_UPDATE_REQUEST_FAILURE = 'APP_BUILDER_UPDATE_REQUEST_FAILURE';

export const APP_BUILDER_CLEAN_REQUEST = 'APP_BUILDER_CLEAN_REQUEST';
export const APP_BUILDER_FIELD_FILTER_CLEAN_REQUEST = 'APP_BUILDER_FIELD_FILTER_CLEAN_REQUEST';

// master country
export const MASTER_COUNTRY_FETCH_REQUEST = 'MASTER_COUNTRY_FETCH_REQUEST';
export const MASTER_COUNTRY_FETCH_REQUEST_SUCCESS = 'MASTER_COUNTRY_FETCH_REQUEST_SUCCESS';
export const MASTER_COUNTRY_FETCH_REQUEST_FAILURE = 'MASTER_COUNTRY_FETCH_REQUEST_FAILURE';

//  command
export const COMMAND_FETCH_REQUEST = 'COMMAND_FETCH_REQUEST';
export const COMMAND_FETCH_REQUEST_SUCCESS = 'COMMAND_FETCH_REQUEST_SUCCESS';
export const COMMAND_FETCH_REQUEST_FAILURE = 'COMMAND_FETCH_REQUEST_FAILURE';
export const COMMAND_CLEAN_REQUEST = 'COMMAND_CLEAN_REQUEST';
export const COMMAND_CLEAN_CRUD_REQUEST = 'COMMAND_CLEAN_CRUD_REQUEST';

export const COMMAND_ADD_REQUEST = 'COMMAND_ADD_REQUEST';
export const COMMAND_ADD_REQUEST_SUCCESS = 'COMMAND_ADD_REQUEST_SUCCESS';
export const COMMAND_ADD_REQUEST_FAILURE = 'COMMAND_ADD_REQUEST_FAILURE';

export const COMMAND_FIELD_FILTER_REQUEST = 'COMMAND_FIELD_FILTER_REQUEST';
export const COMMAND_FIELD_FILTER_REQUEST_SUCCESS = 'COMMAND_FIELD_FILTER_REQUEST_SUCCESS';
export const COMMAND_FIELD_FILTER_REQUEST_FAILURE = 'COMMAND_FIELD_FILTER_REQUEST_FAILURE';
export const COMMAND_FIELD_FILTER_CLEAN_REQUEST = 'COMMAND_FIELD_FILTER_CLEAN_REQUEST';

export const COMMAND_TYPES_REQUEST = 'COMMAND_TYPES_REQUEST';
export const COMMAND_TYPES_REQUEST_SUCCESS = 'COMMAND_TYPES_REQUEST_SUCCESS';
export const COMMAND_TYPES_REQUEST_FAILURE = 'COMMAND_TYPES_REQUEST_FAILURE';
export const COMMAND_TYPES_CLEAN_REQUEST = 'COMMAND_TYPES_CLEAN_REQUEST';

//  banner
export const BANNER_FETCH_REQUEST = 'BANNER_FETCH_REQUEST';
export const BANNER_FETCH_REQUEST_SUCCESS = 'BANNER_FETCH_REQUEST_SUCCESS';
export const BANNER_FETCH_REQUEST_FAILURE = 'BANNER_FETCH_REQUEST_FAILURE';
export const BANNER_CLEAN_REQUEST = 'BANNER_CLEAN_REQUEST';

export const BANNER_ADD_REQUEST = 'BANNER_ADD_REQUEST';
export const BANNER_ADD_REQUEST_SUCCESS = 'BANNER_ADD_REQUEST_SUCCESS';
export const BANNER_ADD_REQUEST_FAILURE = 'BANNER_ADD_REQUEST_FAILURE';

export const BANNER_FIELD_FILTER_REQUEST = 'BANNER_FIELD_FILTER_REQUEST';
export const BANNER_FIELD_FILTER_REQUEST_SUCCESS = 'BANNER_FIELD_FILTER_REQUEST_SUCCESS';
export const BANNER_FIELD_FILTER_REQUEST_FAILURE = 'BANNER_FIELD_FILTER_REQUEST_FAILURE';
export const BANNER_FIELD_FILTER_CLEAN_REQUEST = 'BANNER_FIELD_FILTER_CLEAN_REQUEST';

export const BANNER_TYPES_REQUEST = 'BANNER_TYPES_REQUEST';
export const BANNER_TYPES_REQUEST_SUCCESS = 'BANNER_TYPES_REQUEST_SUCCESS';
export const BANNER_TYPES_REQUEST_FAILURE = 'BANNER_TYPES_REQUEST_FAILURE';
export const BANNER_TYPES_CLEAN_REQUEST = 'BANNER_TYPES_CLEAN_REQUEST';

export const OBJECT_STORAGE_FETCH_REQUEST = 'OBJECT_STORAGE_FETCH_REQUEST';
export const OBJECT_STORAGE_FETCH_REQUEST_SUCCESS = 'OBJECT_STORAGE_FETCH_REQUEST_SUCCESS';
export const OBJECT_STORAGE_FETCH_REQUEST_FAILURE = 'OBJECT_STORAGE_FETCH_REQUEST_FAILURE';
export const OBJECT_STORAGE_CLEAN_REQUEST = 'OBJECT_STORAGE_CLEAN_REQUEST';

export const AUDIT_LOG_FETCH_REQUEST = 'AUDIT_LOG_FETCH_REQUEST';
export const AUDIT_LOG_FETCH_REQUEST_SUCCESS = 'AUDIT_LOG_FETCH_REQUEST_SUCCESS';
export const AUDIT_LOG_FETCH_REQUEST_FAILURE = 'AUDIT_LOG_FETCH_REQUEST_FAILURE';
export const AUDIT_LOG_CLEAN_REQUEST = 'AUDIT_LOG_CLEAN_REQUEST';

// emi schemes
// #region emi_schemes
export const EMI_SCHEME_FETCH_REQUEST = 'EMI_SCHEME_FETCH_REQUEST';
export const EMI_SCHEME_FETCH_REQUEST_SUCCESS = 'EMI_SCHEME_FETCH_REQUEST_SUCCESS';
export const EMI_SCHEME_FETCH_REQUEST_FAILURE = 'EMI_SCHEME_FETCH_REQUEST_FAILURE';
export const EMI_SCHEME_CLEAN_REQUEST = 'EMI_SCHEME_CLEAN_REQUEST';

export const EMI_SCHEME_ADD_REQUEST = 'EMI_SCHEME_ADD_REQUEST';
export const EMI_SCHEME_ADD_REQUEST_SUCCESS = 'EMI_SCHEME_ADD_REQUEST_SUCCESS';
export const EMI_SCHEME_ADD_REQUEST_FAILURE = 'EMI_SCHEME_ADD_REQUEST_FAILURE';

export const EMI_SCHEME_TYPES_FETCH_REQUEST = 'EMI_SCHEME_TYPES_FETCH_REQUEST';
export const EMI_SCHEME_TYPES_FETCH_REQUEST_SUCCESS = 'EMI_SCHEME_TYPES_FETCH_REQUEST_SUCCESS';
export const EMI_SCHEME_TYPES_FETCH_REQUEST_FAILURE = 'EMI_SCHEME_TYPES_FETCH_REQUEST_FAILURE';
export const EMI_SCHEME_TYPES_CLEAN_REQUEST = 'EMI_SCHEME_TYPES_CLEAN_REQUEST';
// #endregion emi_schemes

// Notification
// #notification start

export const NOTIFICATION_FETCH_REQUEST = 'NOTIFICATION_FETCH_REQUEST';
export const NOTIFICATION_FETCH_REQUEST_SUCCESS = 'NOTIFICATION_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_FETCH_REQUEST_FAILURE = 'NOTIFICATION_FETCH_REQUEST_FAILURE';
export const NOTIFICATION_CLEAN_REQUEST = 'NOTIFICATION_CLEAN_REQUEST';

export const NOTIFICATION_ADD_REQUEST = 'NOTIFICATION_ADD_REQUEST';
export const NOTIFICATION_ADD_REQUEST_SUCCESS = 'NOTIFICATION_ADD_REQUEST_SUCCESS';
export const NOTIFICATION_ADD_REQUEST_FAILURE = 'NOTIFICATION_ADD_REQUEST_FAILURE';

export const NOTIFICATION_TYPES_FETCH_REQUEST = 'NOTIFICATION_TYPES_FETCH_REQUEST';
export const NOTIFICATION_TYPES_FETCH_REQUEST_SUCCESS = 'NOTIFICATION_TYPES_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_TYPES_FETCH_REQUEST_FAILURE = 'NOTIFICATION_TYPES_FETCH_REQUEST_FAILURE';
export const NOTIFICATION_TYPES_CLEAN_REQUEST = 'NOTIFICATION_TYPES_CLEAN_REQUEST';

export const NOTIFICATION_APP_FETCH_REQUEST = 'NOTIFICATION_APP_FETCH_REQUEST';
export const NOTIFICATION_APP_FETCH_REQUEST_SUCCESS = 'NOTIFICATION_APP_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_APP_FETCH_REQUEST_FAILURE = 'NOTIFICATION_APP_FETCH_REQUEST_FAILURE';
export const NOTIFICATION_APP_CLEAN_REQUEST = 'NOTIFICATION_APP_CLEAN_REQUEST';

export const NOTIFICATION_ACTION_FETCH_REQUEST = 'NOTIFICATION_ACTION_FETCH_REQUEST';
export const NOTIFICATION_ACTION_FETCH_REQUEST_SUCCESS =
  'NOTIFICATION_ACTION_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_ACTION_FETCH_REQUEST_FAILURE =
  'NOTIFICATION_ACTION_FETCH_REQUEST_FAILURE';
export const NOTIFICATION_ACTION_CLEAN_REQUEST = 'NOTIFICATION_ACTION_CLEAN_REQUEST';

export const NOTIFICATION_MERCHANT_FETCH_REQUEST = 'NOTIFICATION_MERCHANT_FETCH_REQUEST';
export const NOTIFICATION_MERCHANT_FETCH_REQUEST_SUCCESS =
  'NOTIFICATION_MERCHANT_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_MERCHANT_FETCH_REQUEST_FAILURE =
  'NOTIFICATION_MERCHANT_FETCH_REQUEST_FAILURE';
export const NOTIFICATION_MERCHANT_CLEAN_REQUEST = 'NOTIFICATION_MERCHANT_CLEAN_REQUEST';

export const NOTIFICATION_INTERVAL_DROPDOWN_REQUEST = 'NOTIFICATION_INTERVAL_DROPDOWN_REQUEST';
export const NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_SUCCESS =
  'NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_SUCCESS';
export const NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_FAILURE =
  'NOTIFICATION_INTERVAL_DROPDOWN_REQUEST_FAILURE';
export const NOTIFICATION_INTERVAL_DROPDOWN_CLEAN_REQUEST =
  'NOTIFICATION_INTERVAL_DROPDOWN_CLEAN_REQUEST';

// notification audit log
export const NOTIFICATION_AUDIT_LOG_FETCH_REQUEST = 'NOTIFICATION_AUDIT_LOG_FETCH_REQUEST';
export const NOTIFICATION_AUDIT_LOG_FETCH_REQUEST_SUCCESS =
  'NOTIFICATION_AUDIT_LOG_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_AUDIT_LOG_FETCH_REQUEST_FAILURE =
  'NOTIFICATION_AUDIT_LOG_FETCH_REQUEST_FAILURE';
export const NOTIFICATION_AUDIT_LOG_CLEAN_REQUEST = 'NOTIFICATION_AUDIT_LOG_CLEAN_REQUEST';

//notification ends
// bin
// #region bin
export const BIN_FETCH_REQUEST = 'BIN_FETCH_REQUEST';
export const BIN_FETCH_REQUEST_SUCCESS = 'BIN_FETCH_REQUEST_SUCCESS';
export const BIN_FETCH_REQUEST_FAILURE = 'BIN_FETCH_REQUEST_FAILURE';
export const BIN_CLEAN_REQUEST = 'BIN_CLEAN_REQUEST';

export const BIN_ADD_REQUEST = 'BIN_ADD_REQUEST';
export const BIN_ADD_REQUEST_SUCCESS = 'BIN_ADD_REQUEST_SUCCESS';
export const BIN_ADD_REQUEST_FAILURE = 'BIN_ADD_REQUEST_FAILURE';
// #endregion bin

// emi_transaction
// #region emi_transaction
export const EMI_TRANSACTION_FETCH_REQUEST = 'EMI_TRANSACTION_FETCH_REQUEST';
export const EMI_TRANSACTION_FETCH_REQUEST_SUCCESS = 'EMI_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const EMI_TRANSACTION_FETCH_REQUEST_FAILURE = 'EMI_TRANSACTION_FETCH_REQUEST_FAILURE';
export const EMI_TRANSACTION_CLEAN_REQUEST = 'EMI_TRANSACTION_CLEAN_REQUEST';

export const EMI_TRANSACTION_UPDATE_REQUEST = 'EMI_TRANSACTION_UPDATE_REQUEST';
export const EMI_TRANSACTION_UPDATE_REQUEST_SUCCESS = 'EMI_TRANSACTION_UPDATE_REQUEST_SUCCESS';
export const EMI_TRANSACTION_UPDATE_REQUEST_FAILURE = 'EMI_TRANSACTION_UPDATE_REQUEST_FAILURE';

//bnpl
export const BNPL_LIST_FETCH_REQUEST = 'BNPL_LIST_FETCH_REQUEST';
export const BNPL_LIST_FETCH_REQUEST_SUCCESS = 'BNPL_LIST_FETCH_REQUEST_SUCCESS';
export const BNPL_LIST_FETCH_REQUEST_FAILURE = 'BNPL_LIST_FETCH_REQUEST_FAILURE';
export const BNPL_LIST_CLEAN_REQUEST = 'BNPL_LIST_CLEAN_REQUEST';
// #endregion emi_transaction

// settlement
// #region settlement
export const SETTLEMENT_FETCH_REQUEST = 'SETTLEMENT_FETCH_REQUEST';
export const SETTLEMENT_FETCH_REQUEST_SUCCESS = 'SETTLEMENT_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_FETCH_REQUEST_FAILURE = 'SETTLEMENT_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_CLEAN_REQUEST = 'SETTLEMENT_CLEAN_REQUEST';

export const SETTLEMENT_DRAFT_FETCH_REQUEST = 'SETTLEMENT_DRAFT_FETCH_REQUEST';
export const SETTLEMENT_DRAFT_FETCH_REQUEST_SUCCESS = 'SETTLEMENT_DRAFT_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_DRAFT_FETCH_REQUEST_FAILURE = 'SETTLEMENT_DRAFT_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_DRAFT_CLEAN_REQUEST = 'SETTLEMENT_DRAFT_CLEAN_REQUEST';
export const SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST = 'SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST';
export const SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_SUCCESS =
  'SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_FAILURE =
  'SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_DRAFT_DETAIL_CLEAN_REQUEST = 'SETTLEMENT_DRAFT_DETAIL_CLEAN_REQUEST';

export const SETTLEMENT_DETAIL_FETCH_REQUEST = 'SETTLEMENT_DETAIL_FETCH_REQUEST';
export const SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS = 'SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE = 'SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_DETAIL_CLEAN_REQUEST = 'SETTLEMENT_DETAIL_CLEAN_REQUEST';
export const SETTLEMENT_DRAFT_APPROVE_FETCH_REQUEST = 'SETTLEMENT_DRAFT_APPROVE_FETCH_REQUEST';
export const SETTLEMENT_DRAFT_APPROVE_FETCH_REQUEST_SUCCESS =
  'SETTLEMENT_DRAFT_APPROVE_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_DRAFT_APPROVE_FETCH_REQUEST_FAILURE =
  'SETTLEMENT_DRAFT_APPROVE_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_DRAFT_APPROVE_CLEAN_REQUEST = 'SETTLEMENT_DRAFT_APPROVE_CLEAN_REQUEST';
export const SETTLEMENT_DRAFT_REJECT_FETCH_REQUEST = 'SETTLEMENT_DRAFT_REJECT_FETCH_REQUEST';
export const SETTLEMENT_DRAFT_REJECT_FETCH_REQUEST_SUCCESS =
  'SETTLEMENT_DRAFT_REJECT_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_DRAFT_REJECT_FETCH_REQUEST_FAILURE =
  'SETTLEMENT_DRAFT_REJECT_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_DRAFT_REJECT_CLEAN_REQUEST = 'SETTLEMENT_DRAFT_REJECT_CLEAN_REQUEST';
export const SETTLEMENT_TRANSACTIONS_FETCH_REQUEST = 'SETTLEMENT_TRANSACTIONS_FETCH_REQUEST';
export const SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_SUCCESS =
  'SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_FAILURE =
  'SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_TRANSACTIONS_CLEAN_REQUEST = 'SETTLEMENT_TRANSACTIONS_CLEAN_REQUEST';
export const SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST = 'SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST';
export const SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_SUCCESS =
  'SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_SUCCESS';
export const SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_FAILURE =
  'SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_FAILURE';
export const SETTLEMENT_ATTEMPT_DETAIL_CLEAN_REQUEST = 'SETTLEMENT_ATTEMPT_DETAIL_CLEAN_REQUEST';
export const UPLOAD_SETTLEMENT_REQUEST = 'UPLOAD_SETTLEMENT_REQUEST';
export const UPLOAD_SETTLEMENT_REQUEST_SUCCESS = 'UPLOAD_SETTLEMENT_REQUEST_SUCCESS';
export const UPLOAD_SETTLEMENT_REQUEST_FAILURE = 'UPLOAD_SETTLEMENT_REQUEST_FAILURE';

// #endregion settlement
//Qr settlement Report
export const QR_SETTLEMENT_REPORT_FETCH_REQUEST = 'QR_SETTLEMENT_REPORT_FETCH_REQUEST';
export const QR_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS =
  'QR_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS';
export const QR_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE =
  'QR_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE';
export const QR_SETTLEMENT_REPORT_CLEAN_REQUEST = 'QR_SETTLEMENT_REPORT_CLEAN_REQUEST';

//Individual Qr settlement Report
export const QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST =
  'QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST';
export const QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_SUCCESS =
  'QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_SUCCESS';
export const QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_FAILURE =
  'QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_FAILURE';
export const QR_SETTLEMENT_INDIVIDUAL_REPORT_CLEAN_REQUEST =
  'QR_SETTLEMENT_INDIVIDUAL_REPORT_CLEAN_REQUEST';
// qr_provider
// #region qr_provider
export const QR_PROVIDER_FETCH_REQUEST = 'QR_PROVIDER_FETCH_REQUEST';
export const QR_PROVIDER_FETCH_REQUEST_SUCCESS = 'QR_PROVIDER_FETCH_REQUEST_SUCCESS';
export const QR_PROVIDER_FETCH_REQUEST_FAILURE = 'QR_PROVIDER_FETCH_REQUEST_FAILURE';
export const QR_PROVIDER_CLEAN_REQUEST = 'QR_PROVIDER_CLEAN_REQUEST';

export const QR_PROVIDER_ADD_REQUEST = 'QR_PROVIDER_ADD_REQUEST';
export const QR_PROVIDER_ADD_REQUEST_SUCCESS = 'QR_PROVIDER_ADD_REQUEST_SUCCESS';
export const QR_PROVIDER_ADD_REQUEST_FAILURE = 'QR_PROVIDER_ADD_REQUEST_FAILURE';
// #endregion qr_provider

//  support

// support condition staff

export const SUPPORT_STAFF_FETCH_REQUEST = 'SUPPORT_STAFF_FETCH_REQUEST';
export const SUPPORT_STAFF_FETCH_REQUEST_SUCCESS = 'SUPPORT_STAFF_FETCH_REQUEST_SUCCESS';
export const SUPPORT_STAFF_FETCH_REQUEST_FAILURE = 'SUPPORT_STAFF_FETCH_REQUEST_FAILURE';
export const SUPPORT_STAFF_CLEAN_REQUEST = 'SUPPORT_STAFF_CLEAN_REQUEST';

// support condition end

// support edit starts

export const SUPPORT_EDIT_FETCH_REQUEST = 'SUPPORT_EDIT_FETCH_REQUEST';
export const SUPPORT_EDIT_FETCH_REQUEST_SUCCESS = 'SUPPORT_EDIT_FETCH_REQUEST_SUCCESS';
export const SUPPORT_EDIT_FETCH_REQUEST_FAILURE = 'SUPPORT_EDIT_FETCH_REQUEST_FAILURE';
export const SUPPORT_EDIT_CLEAN_REQUEST = 'SUPPORT_EDIT_CLEAN_REQUEST';

// support edit ends

// support complete starts
export const SUPPORT_UPDATE_FETCH_REQUEST = 'SUPPORT_UPDATE_FETCH_REQUEST';
export const SUPPORT_UPDATE_FETCH_REQUEST_SUCCESS = 'SUPPORT_UPDATE_FETCH_REQUEST_SUCCESS';
export const SUPPORT_UPDATE_FETCH_REQUEST_FAILURE = 'SUPPORT_UPDATE_FETCH_REQUEST_FAILURE';
export const SUPPORT_UPDATE_CLEAN_REQUEST = 'SUPPORT_UPDATE_CLEAN_REQUEST';
// support complete ends

//support details
export const SUPPORT_DETAILS_FETCH_REQUEST = 'SUPPORT_DETAILS_FETCH_REQUEST';
export const SUPPORT_DETAILS_FETCH_REQUEST_SUCCESS = 'SUPPORT_DETAILS_FETCH_REQUEST_SUCCESS';
export const SUPPORT_DETAILS_FETCH_REQUEST_FAILURE = 'SUPPORT_DETAILS_FETCH_REQUEST_FAILURE';
export const SUPPORT_DETAILS_CLEAN_REQUEST = 'SUPPORT_DETAILS_CLEAN_REQUEST';

// support assign starts

export const SUPPORT_UPDATE_ASSIGN_REQUEST = 'SUPPORT_UPDATE_ASSIGN_REQUEST';
export const SUPPORT_UPDATE_ASSIGN_REQUEST_SUCCESS = 'SUPPORT_UPDATE_ASSIGN_REQUEST_SUCCESS';
export const SUPPORT_UPDATE_ASSIGN_FAILURE = 'SUPPORT_UPDATE_ASSIGN_REQUEST_FAILURE';
export const SUPPORT_UPDATE_ASSIGN_CLEAN_REQUEST = 'SUPPORT_UPDATE_ASSIGN_CLEAN_REQUEST';

// suport assign ends

// #region support

export const SUPPORT_FETCH_REQUEST = 'SUPPORT_FETCH_REQUEST';
export const SUPPORT_FETCH_REQUEST_SUCCESS = 'SUPPORT_FETCH_REQUEST_SUCCESS';
export const SUPPORT_FETCH_REQUEST_FAILURE = 'SUPPORT_FETCH_REQUEST_FAILURE';
export const SUPPORT_CLEAN_REQUEST = 'SUPPORT_CLEAN_REQUEST';

export const SUPPORT_ADD_REQUEST = 'SUPPORT_ADD_REQUEST';
export const SUPPORT_ADD_REQUEST_SUCCESS = 'SUPPORT_ADD_REQUEST_SUCCESS';
export const SUPPORT_ADD_REQUEST_FAILURE = 'SUPPORT_ADD_REQUEST_FAILURE';
// export const SUPPORT_ADD_CLEAN_REQUEST = 'SUPPORT_ADD_CLEAN_REQUEST';
// dropdown of create ticket support

// proirity dropdown

export const SUPPORT_PRIORITY_FETCH_REQUEST = 'SUPPORT_PRIORITY_FETCH_REQUEST';

export const SUPPORT_PRIORITY_FETCH_REQUEST_SUCCESS = 'SUPPORT_PRIORITY_FETCH_REQUEST_SUCCESS';

export const SUPPORT_PRIORITY_FETCH_REQUEST_FAILURE = 'SUPPORT_PRIORITY_FETCH_REQUEST_FAILURE';
export const SUPPORT_PRIORITY_CLEAN_REQUEST = 'SUPPORT_PRIORITY_CLEAN_REQUEST';

export const SUPPORT_TICKET_TYPE_FETCH_REQUEST = 'SUPPORT_TICKET_TYPE_FETCH_REQUEST';
export const SUPPORT_TICKET_TYPE_FETCH_REQUEST_SUCCESS =
  'SUPPORT_TICKET_TYPE_FETCH_REQUEST_SUCCESS';
export const SUPPORT_TICKET_TYPE_FETCH_REQUEST_FAILURE =
  'SUPPORT_TICKET_TYPE_FETCH_REQUEST_FAILURE';
export const SUPPORT_TICKET_TYPE_CLEAN_REQUEST = 'SUPPORT_TICKET_TYPE_CLEAN_REQUEST';

export const SUPPORT_TICKET_STATUS_FETCH_REQUEST = 'SUPPORT_TICKET_STATUS_FETCH_REQUEST';
export const SUPPORT_TICKET_STATUS_FETCH_REQUEST_SUCCESS =
  'SUPPORT_TICKET_STATUS_FETCH_REQUEST_SUCCESS';
export const SUPPORT_TICKET_STATUS_FETCH_REQUEST_FAILURE =
  'SUPPORT_TICKET_STATUS_FETCH_REQUEST_FAILURE';
export const SUPPORT_TICKET_STATUS_CLEAN_REQUEST = 'SUPPORT_TICKET_STATUS_CLEAN_REQUEST';
export const SUPPORT_TICKET_STATUS_UPDATE_REQUEST = 'SUPPORT_TICKET_STATUS_UPDATE_REQUEST';
export const SUPPORT_TICKET_STATUS_UPDATE_REQUEST_SUCCESS =
  'SUPPORT_TICKET_STATUS_UPDATE_REQUEST_SUCCESS';
export const SUPPORT_TICKET_STATUS_UPDATE_REQUEST_FAILURE =
  'SUPPORT_TICKET_STATUS_UPDATE_REQUEST_FAILURE';
export const SUPPORT_TICKET_STATUS_UPDATE_CLEAN_REQUEST =
  'SUPPORT_TICKET_STATUS_UPDATE_CLEAN_REQUEST';
export const EDIT_SUPPORT_TICKET_REQUEST = 'EDIT_SUPPORT_TICKET_REQUEST';
export const EDIT_SUPPORT_TICKET_REQUEST_SUCCESS = 'EDIT_SUPPORT_TICKET_REQUEST_SUCCESS';
export const EDIT_SUPPORT_TICKET_REQUEST_FAILURE = 'EDIT_SUPPORT_TICKET_REQUEST_FAILURE';
export const EDIT_SUPPORT_TICKET_CLEAN_REQUEST = 'EDIT_SUPPORT_TICKET_CLEAN_REQUEST';
export const SUPPORT_TICKET_SUMMARY_REQUEST = 'SUPPORT_TICKET_SUMMARY_REQUEST';
export const SUPPORT_TICKET_SUMMARY_REQUEST_SUCCESS = 'SUPPORT_TICKET_SUMMARY_REQUEST_SUCCESS';
export const SUPPORT_TICKET_SUMMARY_REQUEST_FAILURE = 'SUPPORT_TICKET_SUMMARY_REQUEST_FAILURE';
export const SUPPORT_TICKET_SUMMARY_CLEAN_REQUEST = 'SUPPORT_TICKET_SUMMARY_CLEAN_REQUEST';
export const SUPPORT_MERCHANT_LIST_FETCH_REQUEST = 'SUPPORT_MERCHANT_LIST_FETCH_REQUEST';
export const SUPPORT_MERCHANT_LIST_FETCH_REQUEST_SUCCESS =
  'SUPPORT_MERCHANT_LIST_FETCH_REQUEST_SUCCESS';
export const SUPPORT_MERCHANT_LIST_FETCH_REQUEST_FAILURE =
  'SUPPORT_MERCHANT_LIST_FETCH_REQUEST_FAILURE';
export const SUPPORT_MERCHANT_LIST_CLEAN_REQUEST = 'SUPPORT_MERCHANT_LIST_CLEAN_REQUEST';

// priority dropdown end

// terminalid dropdown

export const SUPPORT_TERMINAL_ID_FETCH_REQUEST = 'SUPPORT_TERMINAL_ID_FETCH_REQUEST';

export const SUPPORT_TERMINAL_ID_FETCH_REQUEST_SUCCESS =
  'SUPPORT_TERMINAL_ID_FETCH_REQUEST_SUCCESS';

export const SUPPORT_TERMINAL_ID_FETCH_REQUEST_FAILURE =
  'SUPPORT_TERMINAL_ID_FETCH_REQUEST_FAILURE';

export const SUPPORT_TERMINAL_ID_CLEAN_REQUEST = 'SUPPORT_TERMINAL_ID_CLEAN_REQUEST';

// terminalid dropdown end

// reportedto dropdown

export const SUPPORT_REPORTED_TO_FETCH_REQUEST = 'SUPPORT_REPORTED_TO_FETCH_REQUEST';

export const SUPPORT_REPORTED_TO_FETCH_REQUEST_SUCCESS =
  'SUPPORT_REPORTED_TO_FETCH_REQUEST_SUCCESS';

export const SUPPORT_REPORTED_TO_FETCH_REQUEST_FAILURE =
  'SUPPORT_REPORTED_TO_FETCH_REQUEST_FAILURE';

export const SUPPORT_REPORTED_TO_CLEAN_REQUEST = 'SUPPORT_REPORTED_TO_CLEAN_REQUEST';

// reportedto dropdown end

// assign to dropdown

export const SUPPORT_ASSIGN_TO_FETCH_REQUEST = 'SUPPORT_ASSIGN_TO_FETCH_REQUEST';

export const SUPPORT_ASSIGN_TO_FETCH_REQUEST_SUCCESS = 'SUPPORT_ASSIGN_TO_FETCH_REQUEST_SUCCESS';

export const SUPPORT_ASSIGN_TO_FETCH_REQUEST_FAILURE = 'SUPPORT_ASSIGN_TO_FETCH_REQUEST_FAILURE';

export const SUPPORT_ASSIGN_TO_CLEAN_REQUEST = 'SUPPORT_ASSIGN_TO_CLEAN_REQUEST';

// assign to dropdown end

// #endregion support

// member bank
export const MEMBER_BANK_FETCH_REQUEST = 'MEMBER_BANK_FETCH_REQUEST';
export const MEMBER_BANK_FETCH_REQUEST_SUCCESS = 'MEMBER_BANK_FETCH_REQUEST_SUCCESS';
export const MEMBER_BANK_FETCH_REQUEST_FAILURE = 'MEMBER_BANK_FETCH_REQUEST_FAILURE';
export const MEMBER_BANK_CLEAN_REQUEST = 'MEMBER_BANK_CLEAN_REQUEST';

export const MEMBER_BANK_ADD_REQUEST = 'MEMBER_BANK_ADD_REQUEST';
export const MEMBER_BANK_ADD_REQUEST_SUCCESS = 'MEMBER_BANK_ADD_REQUEST_SUCCESS';
export const MEMBER_BANK_ADD_REQUEST_FAILURE = 'MEMBER_BANK_ADD_REQUEST_FAILURE';

// member bank ends

// #region MSF
export const MERCHANT_SCHEME_FETCH_REQUEST = 'MERCHANT_SCHEME_FETCH_REQUEST';
export const MERCHANT_SCHEME_FETCH_REQUEST_SUCCESS = 'MERCHANT_SCHEME_FETCH_REQUEST_SUCCESS';
export const MERCHANT_SCHEME_FETCH_REQUEST_FAILURE = 'MERCHANT_SCHEME_FETCH_REQUEST_FAILURE';
export const MERCHANT_SCHEME_CLEAN_REQUEST = 'MERCHANT_SCHEME_CLEAN_REQUEST';

export const MERCHANT_SCHEME_ADD_REQUEST = 'MERCHANT_SCHEME_ADD_REQUEST';
export const MERCHANT_SCHEME_ADD_REQUEST_SUCCESS = 'MERCHANT_SCHEME_ADD_REQUEST_SUCCESS';
export const MERCHANT_SCHEME_ADD_REQUEST_FAILURE = 'MERCHANT_SCHEME_ADD_REQUEST_FAILURE';

export const MERCHANT_SCHEME_TYPES_FETCH_REQUEST = 'MERCHANT_SCHEME_TYPES_FETCH_REQUEST';
export const MERCHANT_SCHEME_TYPES_FETCH_REQUEST_SUCCESS =
  'MERCHANT_SCHEME_TYPES_FETCH_REQUEST_SUCCESS';
export const MERCHANT_SCHEME_TYPES_FETCH_REQUEST_FAILURE =
  'MERCHANT_SCHEME_TYPES_FETCH_REQUEST_FAILURE';
export const MERCHANT_SCHEME_TYPES_CLEAN_REQUEST = 'MERCHANT_SCHEME_TYPES_CLEAN_REQUEST';
// #endregion MSF

// ISO-BankIntegration

export const BANK_INTEGRATION_ADD_REQUEST = 'BANK_INTEGRATION_ADD_REQUEST';
export const BANK_INTEGRATION_ADD_REQUEST_SUCCESS = 'BANK_INTEGRATION_ADD_REQUEST_SUCCESS';
export const BANK_INTEGRATION_ADD_REQUEST_FAILURE = 'BANK_INTEGRATION_ADD_REQUEST_FAILURE';

export const BANK_INTEGRATION_FETCH_REQUEST = 'BANK_INTEGRATION_FETCH_REQUEST';
export const BANK_INTEGRATION_FETCH_REQUEST_SUCCESS = 'BANK_INTEGRATION_FETCH_REQUEST_SUCCESS';
export const BANK_INTEGRATION_FETCH_REQUEST_FAILURE = 'BANK_INTEGRATION_FETCH_REQUEST_FAILURE';

export const BANK_INTEGRATION_UPDATE_REQUEST = 'BANK_INTEGRATION_UPDATE_REQUEST';
export const BANK_INTEGRATION_UPDATE_REQUEST_SUCCESS = 'BANK_INTEGRATION_UPDATE_REQUEST_SUCCESS';
export const BANK_INTEGRATION_UPDATE_REQUEST_FAILURE = 'BANK_INTEGRATION_UPDATE_REQUEST_FAILURE';

export const BANK_INTEGRATION_CLEAN_REQUEST = 'BANK_INTEGRATION_CLEAN_REQUEST';

//CARD SETTLEMENT

export const CARD_SETTLEMENT_FETCH_REQUEST = 'CARD_SETTLEMENT_FETCH_REQUEST';
export const CARD_SETTLEMENT_FETCH_REQUEST_SUCCESS = 'CARD_SETTLEMENT_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_FETCH_REQUEST_FAILURE = 'CARD_SETTLEMENT_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_CLEAN_REQUEST = 'CARD_SETTLEMENT_CLEAN_REQUEST';

export const CARD_SETTLEMENT_ADD_REQUEST = 'CARD_SETTLEMENT_ADD_REQUEST';
export const CARD_SETTLEMENT_ADD_REQUEST_SUCCESS = 'CARD_SETTLEMENT_ADD_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_ADD_REQUEST_FAILURE = 'CARD_SETTLEMENT_ADD_REQUEST_FAILURE';

export const CARD_SETTLEMENT_UPDATE_REQUEST = 'CARD_SETTLEMENT_UPDATE_REQUEST';
export const CARD_SETTLEMENT_UPDATE_REQUEST_SUCCESS = 'CARD_SETTLEMENT_UPDATE_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_UPDATE_REQUEST_FAILURE = 'CARD_SETTLEMENT_UPDATE_REQUEST_FAILURE';

export const CARD_SETTLEMENT_MCC_FETCH_REQUEST = 'CARD_SETTLEMENT_MCC_FETCH_REQUEST';
export const CARD_SETTLEMENT_MCC_FETCH_REQUEST_SUCCESS =
  'CARD_SETTLEMENT_MCC_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_MCC_FETCH_REQUEST_FAILURE =
  'CARD_SETTLEMENT_MCC_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_MCC_CLEAN_REQUEST = 'CARD_SETTLEMENT_MCC_CLEAN_REQUEST';

export const CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST = 'CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST';
export const CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_SUCCESS =
  'CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_FAILURE =
  'CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_GROUP_BY_CLEAN_REQUEST = 'CARD_SETTLEMENT_GROUP_BY_CLEAN_REQUEST';
//  merchant settlement
export const CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST = 'CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST';
export const CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS =
  'CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS';
export const CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE =
  'CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE';
export const CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST = 'CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST';
// settle card merchant settlement
export const SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST =
  'SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST';
export const SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS =
  'SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS';
export const SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE =
  'SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE';
export const SETTLE_CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST =
  'SETTLE_CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST';
//  card  settlement report
export const CARD_SETTLEMENT_REPORT_FETCH_REQUEST = 'CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST';
export const CARD_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS =
  'CARD_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE =
  'CARD_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_REPORT_CLEAN_REQUEST = 'CARD_SETTLEMENT_REPORT_CLEAN_REQUEST';

export const CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST =
  'CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST';
export const CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_SUCCESS =
  'CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_FAILURE =
  'CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_REPORT_SUMMARY_CLEAN_REQUEST =
  'CARD_SETTLEMENT_REPORT_SUMMARY_CLEAN_REQUEST';

export const CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST =
  'CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST';
export const CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_SUCCESS =
  'CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_FAILURE =
  'CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_REPORT_SUMMARY_LIST_CLEAN_REQUEST =
  'CARD_SETTLEMENT_REPORT_SUMMARY_LIST_CLEAN_REQUEST';

export const CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST =
  'CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST';
export const CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_SUCCESS =
  'CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_SUCCESS';
export const CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_FAILURE =
  'CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_FAILURE';
export const CARD_SETTLEMENT_REPORT_BATCH_LIST_CLEAN_REQUEST =
  'CARD_SETTLEMENT_REPORT_BATCH_LIST_CLEAN_REQUEST';

export const CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST =
  'CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST';
export const CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS =
  'CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS';
export const CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE =
  'CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE';
export const CARD_MERCHANT_SETTLEMENT_DETAIL_CLEAN_REQUEST =
  'CARD_MERCHANT_SETTLEMENT_DETAIL_CLEAN_REQUEST';

//Receipt Configuration
export const RECEIPT_CONFIGURATION_ADD_REQUEST = 'RECEIPT_CONFIGURATION_ADD_REQUEST';
export const RECEIPT_CONFIGURATION_ADD_REQUEST_SUCCESS =
  'RECEIPT_CONFIGURATION_ADD_REQUEST_SUCCESS';
export const RECEIPT_CONFIGURATION_ADD_REQUEST_FAILURE =
  'RECEIPT_CONFIGURATION_ADD_REQUEST_FAILURE';

export const RECEIPT_CONFIGURATION_FETCH_REQUEST = 'RECEIPT_CONFIGURATION_FETCH_REQUEST';
export const RECEIPT_CONFIGURATION_FETCH_REQUEST_SUCCESS =
  'RECEIPT_CONFIGURATION_FETCH_REQUEST_SUCCESS';
export const RECEIPT_CONFIGURATION_FETCH_REQUEST_FAILURE =
  'RECEIPT_CONFIGURATION_FETCH_REQUEST_FAILURE';

export const RECEIPT_CONFIGURATION_UPDATE_REQUEST = 'RECEIPT_CONFIGURATION_UPDATE_REQUEST';
export const RECEIPT_CONFIGURATION_UPDATE_REQUEST_SUCCESS =
  'RECEIPT_CONFIGURATION_UPDATE_REQUEST_SUCCESS';
export const RECEIPT_CONFIGURATION_UPDATE_REQUEST_FAILURE =
  'RECEIPT_CONFIGURATION_UPDATE_REQUEST_FAILURE';

export const RECEIPT_CONFIGURATION_CLEAN_REQUEST = 'RECEIPT_CONFIGURATION_CLEAN_REQUEST';

//transaction BarGraph DropDown
export const TRANSACTION_BARGRAPH_DROPDOWN_REQUEST = 'TRANSACTION_BARGRAPH_DROPDOWN_REQUEST';
export const TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_SUCCESS =
  'TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_SUCCESS';
export const TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_FAILURE =
  'TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_FAILURE';

//transaction BarGraph
export const TRANSACTION_BARGRAPH_FETCH_REQUEST = 'TRANSACTION_BARGRAPH_FETCH_REQUEST';
export const TRANSACTION_BARGRAPH_FETCH_REQUEST_SUCCESS =
  'TRANSACTION_BARGRAPH_FETCH_REQUEST_SUCCESS';
export const TRANSACTION_BARGRAPH_FETCH_REQUEST_FAILURE =
  'TRANSACTION_BARGRAPH_FETCH_REQUEST_FAILURE';

//transaction Bargraph Currency Dropdown
export const TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST =
  'TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST';
export const TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_SUCCESS =
  'TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_SUCCESS';
export const TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_FAILURE =
  'TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_FAILURE';

// terminal Configure switch
export const TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST =
  'TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST';
export const TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_SUCCESS =
  'TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_SUCCESS';
export const TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_FAILURE =
  'TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_FAILURE';
export const TERMINAL_CONFIGURE_SWITCH_KCV_CLEAN_REQUEST =
  'TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_CLEAN_REQUEST';

// device password setup
export const DEVICE_PASSWORD_SETUP_ADD_REQUEST = 'DEVICE_PASSWORD_SETUP_ADD_REQUEST';
export const DEVICE_PASSWORD_SETUP_ADD_REQUEST_SUCCESS =
  'DEVICE_PASSWORD_SETUP_ADD_REQUEST_SUCCESS';
export const DEVICE_PASSWORD_SETUP_ADD_REQUEST_FAILURE =
  'DEVICE_PASSWORD_SETUP_ADD_REQUEST_FAILURE';

export const DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST =
  'DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST';
export const DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_SUCCESS =
  'DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_SUCCESS';
export const DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_FAILURE =
  'DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_FAILURE';
export const DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST =
  'DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST';
export const DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_SUCCESS =
  'DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_SUCCESS';
export const DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_FAILURE =
  'DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_FAILURE';

export const DEVICE_PASSWORD_SETUP_UPDATE_REQUEST = 'DEVICE_PASSWORD_SETUP_UPDATE_REQUEST';
export const DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_SUCCESS =
  'DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_SUCCESS';
export const DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_FAILURE =
  'DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_FAILURE';

export const DEVICE_PASSWORD_SETUP_FETCH_REQUEST = 'DEVICE_PASSWORD_SETUP_FETCH_REQUEST';
export const DEVICE_PASSWORD_SETUP_FETCH_REQUEST_SUCCESS =
  'DEVICE_PASSWORD_SETUP_FETCH_REQUEST_SUCCESS';
export const DEVICE_PASSWORD_SETUP_FETCH_REQUEST_FAILURE =
  'DEVICE_PASSWORD_SETUP_FETCH_REQUEST_FAILURE';

export const DEVICE_PASSWORD_SETUP_CLEAN_REQUEST = 'DEVICE_PASSWORD_SETUP_CLEAN_REQUEST';

// System Integration
export const BILLING_SYSTEM_FORM_FETCH_REQUEST = 'BILLING_SYSTEM_FORM_FETCH_REQUEST';
export const BILLING_SYSTEM_FORM_FETCH_REQUEST_SUCCESS =
  'BILLING_SYSTEM_FORM_FETCH_REQUEST_SUCCESS';
export const BILLING_SYSTEM_FORM_VERSIONS_FETCH_REQUEST_SUCCESS =
  'BILLING_SYSTEM_FORM_VERSIONS_FETCH_REQUEST_SUCCESS';
export const BILLING_SYSTEM_FORM_FETCH_REQUEST_FAILURE =
  'BILLING_SYSTEM_FORM_FETCH_REQUEST_FAILURE';
export const BILLING_SYSTEM_FORM_CLEAN_REQUEST = 'BILLING_SYSTEM_FORM_CLEAN_REQUEST';

export const BILLING_SYSTEM_FETCH_REQUEST = 'BILLING_SYSTEM_FETCH_REQUEST';
export const BILLING_SYSTEM_FETCH_REQUEST_SUCCESS = 'BILLING_SYSTEM_FETCH_REQUEST_SUCCESS';
export const BILLING_SYSTEM_FETCH_REQUEST_FAILURE = 'BILLING_SYSTEM_FETCH_REQUEST_FAILURE';
export const BILLING_SYSTEM_CLEAN_REQUEST = 'BILLING_SYSTEM_CLEAN_REQUEST';

// Txn Requests (billing.transactions)
export const BILLING_TRANSACTION_FETCH_REQUEST = 'BILLING_TRANSACTION_FETCH_REQUEST';
export const BILLING_TRANSACTION_FETCH_REQUEST_SUCCESS =
  'BILLING_TRANSACTION_FETCH_REQUEST_SUCCESS';
export const BILLING_TRANSACTION_FETCH_REQUEST_FAILURE =
  'BILLING_TRANSACTION_FETCH_REQUEST_FAILURE';
export const BILLING_TRANSACTION_CLEAN_REQUEST = 'BILLING_TRANSACTION_CLEAN_REQUEST';
export const BILLING_TRANSACTION_FILTER_FIELD_SUCCESS = 'BILLING_TRANSACTION_FILTER_FIELD_SUCCESS';

// Vendor
export const BILLING_VENDOR_ADD_REQUEST = 'BILLING_VENDOR_ADD_REQUEST';
export const BILLING_VENDOR_ADD_REQUEST_SUCCESS = 'BILLING_VENDOR_ADD_REQUEST_SUCCESS';
export const BILLING_VENDOR_ADD_REQUEST_FAILURE = 'BILLING_VENDOR_ADD_REQUEST_FAILURE';
export const BILLING_VENDOR_ADD_CLEAN_REQUEST = 'BILLING_VENDOR_ADD_CLEAN_REQUEST';

export const BILLING_VENDOR_FETCH_REQUEST = 'BILLING_VENDOR_FETCH_REQUEST';
export const BILLING_VENDOR_FETCH_REQUEST_SUCCESS = 'BILLING_VENDOR_FETCH_REQUEST_SUCCESS';
export const BILLING_VENDOR_FETCH_REQUEST_FAILURE = 'BILLING_VENDOR_FETCH_REQUEST_FAILURE';
export const BILLING_VENDOR_RESET_LOADING = 'BILLING_VENDOR_RESET_LOADING';
export const BILLING_VENDOR_CLEAN_REQUEST = 'BILLING_VENDOR_CLEAN_REQUEST';
